webpackJsonp([0],Array(18).concat([
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(64)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Jiagou__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Jiagou___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Jiagou__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Zeren__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Zeren___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Zeren__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Shengming__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Shengming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Shengming__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Wenhua__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Wenhua___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Wenhua__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ContactUs__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Yingyong__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Yingyong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Yingyong__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_JobCategory__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_JobCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_JobCategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_BlogHome__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_BlogHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_BlogHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_BlogDetails__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_BlogDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_BlogDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_JobSearch__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_JobSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_JobSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_JobSingle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_JobSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_JobSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_PricingPlan__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_PricingPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_PricingPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Elements__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_Elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Fuwu__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Fuwu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_Fuwu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Fangan__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Fangan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Fangan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Chanpin__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Chanpin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_Chanpin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Jiejueinfo__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Jiejueinfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_Jiejueinfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_huoban__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_huoban___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_huoban__);























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */])

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
    },
    {
      path: '/about',
      name: 'about',
      component: __WEBPACK_IMPORTED_MODULE_3__pages_About___default.a
    },
    {
      path: '/huoban',
      name: 'huoban',
      component: __WEBPACK_IMPORTED_MODULE_21__pages_huoban___default.a
    },
    {
      path: '/chanpin',
      name: 'chanpin',
      component: __WEBPACK_IMPORTED_MODULE_19__pages_Chanpin___default.a
    },
    {
      path: '/jiejueinfo',
      name: 'jiejueinfo',
      component: __WEBPACK_IMPORTED_MODULE_20__pages_Jiejueinfo___default.a
    },
    {
      path: '/fuwu',
      name: 'fuwu',
      component: __WEBPACK_IMPORTED_MODULE_17__pages_Fuwu___default.a
    },
    {
      path: '/fangan',
      name: 'fangan',
      component: __WEBPACK_IMPORTED_MODULE_18__pages_Fangan___default.a
    },
    {
      path: '/jiagou',
      name: 'jiagou',
      component: __WEBPACK_IMPORTED_MODULE_4__pages_Jiagou___default.a
    },
    {
      path: '/zeren',
      name: 'zeren',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_Zeren___default.a
    },
    {
      path: '/yingyong',
      name: 'yingyong',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_Yingyong___default.a
    },
    {
      path: '/shengming',
      name: 'shengming',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_Shengming___default.a
    },
    {
      path: '/wenhua',
      name: 'wenhua',
      component: __WEBPACK_IMPORTED_MODULE_7__pages_Wenhua___default.a
    },
    {
      path: '/category',
      name: 'category',
      component: __WEBPACK_IMPORTED_MODULE_10__pages_JobCategory___default.a
    },
    {
      path: '/blog',
      name: 'blog',
      component: __WEBPACK_IMPORTED_MODULE_11__pages_BlogHome___default.a
    },
    {
      path: '/blogDetails',
      name: 'blogDetails',
      component: __WEBPACK_IMPORTED_MODULE_12__pages_BlogDetails___default.a
    },
    {
      path: '/contact',
      name: 'contact',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_ContactUs___default.a
    },
    {
      path: '/jobSearch',
      name: 'jobSearch',
      component: __WEBPACK_IMPORTED_MODULE_13__pages_JobSearch___default.a
    },
    {
      path: '/jobSingle',
      name: 'jobSingle',
      component: __WEBPACK_IMPORTED_MODULE_14__pages_JobSingle___default.a
    },
    {
      path: '/pricingPlan',
      name: 'pricingPlan',
      component: __WEBPACK_IMPORTED_MODULE_15__pages_PricingPlan___default.a
    },
    {
      path: '/elements',
      name: 'elements',
      component: __WEBPACK_IMPORTED_MODULE_16__pages_Elements___default.a
    }
  ]
}));


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */])

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  modules: {
  }
}));


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      messtel: '',
      messname: '',
      messtitle: '',
      isVisibleb: false,
      keyValue: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.qiyeinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.zhandianinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.daohanglist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    toggleVisibility: function toggleVisibility() {
      console.log('3333');
      this.isVisibleb = !this.isVisibleb;
    },
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    buttonmess: function buttonmess() {
      var _this2 = this;

      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        }).then(function (response) {
          alert('留言提交成功!');
          _this2.messname = '';
          _this2.messtel = '';
          _this2.messtitle = '';
        }).catch(function (error) {
          console.error('当前网络环境异常!', error);
        });
      } else {
        alert('内容不能为空');
        return;
      }
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/21', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.aboutinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return dateStr.substring(0, length);
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {

			newslist: [],
			qiyeinfo: [],
			zhandianinfo: [],
			daohanglist: [],
			messtel: '',
			messname: '',
			messtitle: '',
			thisid: '',
			cid: '',
			newsinfo: [],
			newurl: 'https://naduapi.jurenkeji.com.cn'
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.scrollToTop(780);

		this.thisid = this.$route.query.id;
		this.cid = this.$route.query.cid;

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.qiyeinfo = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.zhandianinfo = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.daohanglist = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/' + this.cid + '/num/3', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.newslist = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/' + this.thisid, {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.newsinfo = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});
	},

	methods: {
		reloadPage: function reloadPage() {
			window.location.reload();
		},
		truncatecontent: function truncatecontent(dateStr) {
			var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

			return dateStr.substring(0, length);
		},
		scrollToTop: function scrollToTop(e) {
			window.scrollTo({
				top: e,
				behavior: 'smooth' });
		}
	}
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      newtitle: '',
      newslist: [],
      newslunbo: [{
        id: '',
        ico: '',
        date: '',
        title: '',
        description: ''
      }, {
        id: '',
        ico: '',
        date: '',
        title: '',
        description: ''
      }, {
        id: '',
        ico: '',
        date: '',
        title: '',
        description: ''
      }],
      numzong: 6,
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      messtel: '',
      messname: '',
      messtitle: '',
      thisid: '',
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.thisid = this.$route.query.id;
    if (this.thisid == 15) {
      this.newtitle = '新闻';
    } else {
      this.newtitle = '技术文章';
    }

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.qiyeinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.zhandianinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.daohanglist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/xwttlist/num/' + this.thisid, {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.newslunbo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/' + this.thisid + '/num/' + this.numzong + '/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.newslist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    truncatechanpinzzz: function truncatechanpinzzz(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;

      return dateStr.substring(0, length) + '...';
    },
    jiazai: function jiazai(num) {
      var _this2 = this;

      var zong = num + 3;
      if (this.newslist.length < num) {
        console.log(this.newslist.length, num);
        alert('已经没有更多' + this.newtitle + '!');
      } else {

        this.numzong = zong;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/' + this.thisid + '/num/' + zong + '/order/sorting', {
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        }).then(function (response) {
          _this2.newslist = response.data.data;
        }).catch(function (error) {
          console.error('当前网络环境异常!', error);
        });
      }
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cpinfo: [],
      thisid: '',
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.thisid = this.$route.query.id;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/' + this.thisid, {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      if (response.data.data.description.includes('●')) {
        response.data.data.description = response.data.data.content;
      }
      _this.cpinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return dateStr.substring(0, length);
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      lianxiwomen: [],
      showPopup: false,
      componentReady: false,
      linian1: [],
      linian2: [],
      fazhan: [],
      zhaopin: [],
      messtel: '',
      messname: '',
      messtitle: '',
      zhaopininfo: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.componentReady = true;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.qiyeinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.zhandianinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.daohanglist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/19', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.lianxiwomen = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/48', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.linian1 = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/49', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.linian2 = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/46', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.fazhan = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/47', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.zhaopin = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    openPopup: function openPopup(e) {
      this.showPopup = true;
      this.zhaopininfo = e;
    },
    guanbitc: function guanbitc() {
      this.showPopup = false;
    },
    buttonmess: function buttonmess() {
      var _this2 = this;

      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        }).then(function (response) {
          alert('留言提交成功!');
          _this2.messname = '';
          _this2.messtel = '';
          _this2.messtitle = '';
        }).catch(function (error) {
          console.error('当前网络环境异常!', error);
        });
      } else {
        alert('内容不能为空');
        return;
      }
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      page: 1,
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      messtel: '',
      messname: '',
      messtitle: '',
      fanganlist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
      fanganinfo: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.qiyeinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.zhandianinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/6/page/1', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.fanganlist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/sort/scode/13', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.fanganinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;

      return dateStr.substring(0, length);
    },
    truncatecontentb: function truncatecontentb(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

      return dateStr.substring(0, length);
    },
    qiehuanzus: function qiehuanzus(pages) {
      var _this2 = this;

      console.log(pages);

      if (pages > 1) {
        var page = pages - 1;
      } else {
        var page = 1;
      }
      var that = this;
      this.page = page;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/6/page/' + page, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        console.log(response.data);
        if (response.data.code == 1) {

          _this2.fanganlist = response.data.data;
        } else {
          _this2.fanganlist = response.data.data;
        }
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    },
    qiehuanzux: function qiehuanzux(pages) {
      var _this3 = this;

      console.log(pages);

      var page = pages + 1;
      this.page = page;
      var that = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/6/page/' + page, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        if (response.data.code == 0) {
          that.page = pages;
          alert('当前已是最后一组');
        } else {
          _this3.fanganlist = response.data.data;
        }
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    },
    buttonmess: function buttonmess() {
      var _this4 = this;

      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        }).then(function (response) {
          alert('留言提交成功!');
          _this4.messname = '';
          _this4.messtel = '';
          _this4.messtitle = '';
        }).catch(function (error) {
          console.error('当前网络环境异常!', error);
        });
      } else {
        alert('内容不能为空');
        return;
      }
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isMobile: false,
      fuwuinfo: [],

      fuwuname: '服务宗旨',
      fuwuid: 34,

      fuwulist: [],
      tablelist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.id) {
      this.fuwuid = this.$route.query.id;
    }
    this.checkIfMobile();

    document.addEventListener('DOMContentLoaded', function () {
      var toggleButton = document.getElementById('toggleButton');
      var toggleDiv = document.getElementById('toggleDivzzy');


      toggleButton.addEventListener('click', function () {

        if (toggleDiv.style.display === 'none' || toggleDiv.style.display === '') {
          toggleDiv.style.display = 'block';
        } else {
          toggleDiv.style.display = 'none';
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.fuwulist = response.data.data;
      _this.tablelist = _this.fuwulist[3]['son'][0]['son'];
      console.log(_this.fuwulist[3]['son'][0]['son']);
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/25', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.aboutinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
    this.fuwuinfoan(this.fuwuid);
  },

  methods: {
    checkIfMobile: function checkIfMobile() {
      var isMobile = window.innerWidth <= 800;
      console.log('Is Mobile:', isMobile);
      if (isMobile == true) {
        this.yincangdivb();
      } else {
        this.yincangdiv();
      }
    },
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return dateStr.substring(0, length);
    },
    yincangdiv: function yincangdiv() {
      var toggleDivb = document.getElementById('toggleDivzzy');
      toggleDivb.style.display = 'none';
    },
    yincangdivb: function yincangdivb() {
      console.log(22222);
      var toggleDivz = document.getElementById('toggleDivzzy');
      toggleDivz.style.display = 'block';
    },
    fuwuinfoan: function fuwuinfoan(e) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/' + e, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this2.fuwuinfo = response.data.data;
        _this2.fuwuname = response.data.data.title;
        _this2.fuwuid = response.data.data.id;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    },
    fuwuinfoanb: function fuwuinfoanb(e) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/' + e, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this3.fuwuinfo = response.data.data;
        _this3.fuwuname = response.data.data.title;
        _this3.fuwuid = response.data.data.id;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
      this.yincangdiv();
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      newurl: 'https://naduapi.jurenkeji.com.cn',
      aboutinfo: '',
      messtel: '',
      messname: '',
      messtitle: '',
      lanmulist: [],
      qiyeinfo: [],
      zhandianinfo: [],
      prbuclist: [{
        id: ''

      }, {
        id: ''

      }, {
        id: ''

      }, {
        id: ''

      }],
      huobanlist: [{
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }],
      huobanlista: [{
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }],
      newslist: [],
      fuwulist: [{
        ico: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }, {
        pics: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }, {
        pics: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }, {
        ico: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }, {
        pics: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }],
      hangyelist: [{
        ico: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }, {
        pics: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }, {
        pics: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }, {
        ico: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }, {
        pics: "/static/upload/image/20240806/1722927385513502.jpg",
        id: "108",
        title: "半导体（拿度）",
        description: "在半导体芯片制造工程中"
      }],
      fanganlist: [{
        pics: "/static/upload/image/20240806/1722923425968374.jpg",
        id: "104",
        title: "工程机械设备智能领域",
        description: "超声波传感器具有频率高、波长短、绕射现象小，特别是方向性好、能够成为射线而定向传播等特点。超声波对液体、固体的穿透本领很大，尤其是在阳光不透明的固体中。广泛应用于工业无损探伤、测厚、物位（液位）监测，机器人防撞，各种超声波接近开关，防盗报警，以及国防、医疗等相关领域。"
      }, {
        pics: "/static/upload/image/20240806/1722923368670619.jpg",
        id: "103",
        title: "汽车设备智能制造领域",
        description: "磁致伸缩位移传感器具有高可靠性、高分辨率、非接触测量、耐油抗污等特殊优点，能在恶劣的工业环境下，对各种运动部件的位移（位置）、速度进行连续、精确、实时的检测，是实现精确操作和控制的重要元件，可大幅提高整个系统的精度和效率。"
      }, {
        pics: "/static/upload/image/20240806/1722923303305293.jpg",
        id: "102",
        title: "芯片设备制造领域",
        description: "激光传感器的优点是能实现无接触远距离测量，速度快，精度高，量程大，抗光、电干扰能力强等。广泛应用于长度、距离、振动、速度、方位等物理量的测量，还可用于探伤和大气污染物的监测等。"
      }],
      bannerlist: [{
        acode: "cn",
        create_time: "2024-06-18 17:23:41",
        create_user: "admin",
        gid: "1",
        id: "9",
        link: "",
        pic: "../../static/assets/images/bannerc.jpg",
        sorting: "255",
        subtitle: "A source of motivation to explore the unknown",
        title: "探索未知世界的源动力",
        update_time: " 2024-08-05 15:55:29",
        update_user: "admin"
      }, {
        acode: "cn",
        create_time: "2024-08-05 15:56:06",
        create_user: "admin",
        gid: "1",
        id: "10",
        link: "",
        pic: "../../static/assets/images/bannerc.jpg",
        sorting: "255",
        subtitle: "A source of motivation to explore the unknown",
        title: "探索未知世界的源动力 测试1",
        update_time: " 2024-08-05 15:56:16",
        update_user: "admin"
      }, {
        acode: "cn",
        create_time: "2024-08-05 15:56:29",
        create_user: "admin",
        gid: "1",
        id: "11",
        link: "",
        pic: "../../static/assets/images/bannerc.jpg",
        sorting: "255",
        subtitle: "A source of motivation to explore the unknown",
        title: "探索未知世界的源动力 测试2",
        update_time: "2024-08-05 15:56:29",
        update_user: "admin"
      }, {
        acode: "cn",
        create_time: "2024-08-05 15:56:49",
        create_user: "admin",
        gid: "1",
        id: "12",
        link: "",
        pic: "../../static/assets/images/bannerc.jpg",
        sorting: "255",
        subtitle: "A source of motivation to explore the unknown",
        title: "探索未知世界的源动力 测试3",
        update_time: "2024-08-05 15:56:49",
        update_user: "admin"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/slide/gid/1/num/4', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.bannerlist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/7/num/4/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.prbuclist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav/scode/7', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.lanmulist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/3/order/sorting', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this.fanganlist = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/236', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this.aboutinfo = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    }, 6000);
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/26/num/4/order/sorting', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this.hangyelist = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    }, 7000);
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/50/num/5/order/sorting', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this.fuwulist = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    }, 8000);
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/14/num/4/order/sorting', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this.newslist = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    }, 10000);
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this.qiyeinfo = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this.zhandianinfo = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    }, 6500);
  },
  created: function created() {},

  methods: {
    truncateDate: function truncateDate(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

      return dateStr.substring(0, length);
    },
    truncatetitle: function truncatetitle(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

      return dateStr.substring(0, length);
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;

      return dateStr.substring(0, length);
    },
    truncatechanpin: function truncatechanpin(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

      return dateStr.substring(0, length);
    },
    buttonmess: function buttonmess() {
      var _this2 = this;

      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        }).then(function (response) {
          alert('留言提交成功!');
          _this2.messname = '';
          _this2.messtel = '';
          _this2.messtitle = '';
        }).catch(function (error) {
          console.error('当前网络环境异常!', error);
        });
      } else {
        alert('内容不能为空');
        return;
      }
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/23', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.aboutinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return dateStr.substring(0, length);
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      aboutinfo: [],
      tuijianlist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
      waiurl: 'https://na-do.com'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.thisid = this.$route.query.id;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/' + this.thisid, {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.aboutinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/3', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.tuijianlist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return dateStr.substring(0, length);
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scodein: 7,
      daohanglist: [],
      chanpintab: [],
      itemscode: 8,
      thisid: 8,
      itemscodeb: 27,
      mouseOverFired: false,
      mouseOverFiredb: false,
      listsp: [],
      pubiclist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
      listinfo: [{
        id: '',
        title: '',
        en: ''

      }, {
        id: '',
        title: '',
        en: ''

      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log(this.scodein);

    this.thisid = this.$route.query.id;
    this.itemscode = this.thisid;
    this.scodein = this.thisid;
    this.qingqiufenlei(this.thisid);
    this.chanpinlist(this.thisid);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.daohanglist = response.data.data;
      _this.chanpintab = _this.daohanglist[1];
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    listinfoan: function listinfoan() {},
    handleMouseOver: function handleMouseOver(event) {
      if (!this.mouseOverFired) {
        this.scodein = event;
        this.mouseOverFired = true;
        this.qingqiufenlei(event);
        this.chanpinlist(event);
      }
    },
    handleMouseLeave: function handleMouseLeave(event) {
      this.mouseOverFired = false;
      this.itemscode = event;
    },
    handleMouseOverb: function handleMouseOverb(event) {
      if (!this.mouseOverFiredb) {
        this.scodein = event;

        this.mouseOverFiredb = true;
        this.chanpinlist(event);
      }
    },
    handleMouseLeaveb: function handleMouseLeaveb(event) {
      this.mouseOverFiredb = false;
      this.itemscodeb = event;
    },
    qingqiufenlei: function qingqiufenlei(e) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav/scode/' + e, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this2.listinfo = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    },
    chanpinlist: function chanpinlist(e) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/' + e + '/page/1/num/100', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        _this3.pubiclist = response.data.data;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			huobanlist: [{
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}],
			qiyeinfo: [],
			zhandianinfo: [],
			daohanglist: [],
			messtel: '',
			messname: '',
			messtitle: '',
			newurl: 'https://naduapi.jurenkeji.com.cn'
		};
	},
	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.qiyeinfo = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.zhandianinfo = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.daohanglist = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/29/num/20/order/sorting', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.huobanlist = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});
	},

	methods: {
		buttonmess: function buttonmess() {
			var _this2 = this;

			if (this.messname != '' && this.messtel != '' && this.messtitle) {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
					name: this.messname,
					tel: this.messtel,
					content: this.messtitle,
					appid: 'jurenkeji2024',
					timestamp: '1722845854',
					signature: '0eb76b812e96966c380b90c6e7416a26'
				}).then(function (response) {
					alert('留言提交成功!');
					_this2.messname = '';
					_this2.messtel = '';
					_this2.messtitle = '';
				}).catch(function (error) {
					console.error('当前网络环境异常!', error);
				});
			} else {
				alert('内容不能为空');
				return;
			}
		}
	}
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			qiyeinfo: [],
			zhandianinfo: [],
			daohanglist: [],
			messtel: '',
			messname: '',
			messtitle: '',

			huobanlist: [{
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}],
			huobanlista: [{
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}, {
				ico: '',
				id: '',
				title: ''
			}],
			newurl: 'https://naduapi.jurenkeji.com.cn'
		};
	},
	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.qiyeinfo = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.zhandianinfo = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/17/num/20/page/2/order/sorting', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.huobanlista = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.daohanglist = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/30/num/20/order/sorting', {
			appid: 'jurenkeji2024',
			timestamp: '1722845854',
			signature: '0eb76b812e96966c380b90c6e7416a26'
		}).then(function (response) {
			_this.huobanlist = response.data.data;
		}).catch(function (error) {
			console.error('当前网络环境异常!', error);
		});
	},

	methods: {
		buttonmess: function buttonmess() {
			var _this2 = this;

			if (this.messname != '' && this.messtel != '' && this.messtitle) {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
					name: this.messname,
					tel: this.messtel,
					content: this.messtitle,
					appid: 'jurenkeji2024',
					timestamp: '1722845854',
					signature: '0eb76b812e96966c380b90c6e7416a26'
				}).then(function (response) {
					alert('留言提交成功!');
					_this2.messname = '';
					_this2.messtel = '';
					_this2.messtitle = '';
				}).catch(function (error) {
					console.error('当前网络环境异常!', error);
				});
			} else {
				alert('内容不能为空');
				return;
			}
		}
	}
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/25', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.aboutinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return dateStr.substring(0, length);
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/22', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.aboutinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return dateStr.substring(0, length);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      xuanzhong: '',
      cplist: [],
      hangyelist: [],
      fenleixz: 7,
      cpinfo: [],
      key: '',
      issum: 1,
      countsum: 1,
      prductlist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/yingyonglist/name/ext_c4', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.hangyelist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/7/page/1', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.cpinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav/scode/7', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.cplist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    this.key = this.$route.query.key;
    if (this.key === undefined || this.key === null || this.key.trim() === '') {
      this.key = '';
    }
    this.huoqulist(this.fenleixz, this.xuanzhong, this.key);
  },

  methods: {
    fenlei: function fenlei(e) {
      this.fenleixz = e;
      this.huoqulist(e, this.xuanzhong);
    },
    hangyexz: function hangyexz(e) {
      this.xuanzhong = e;
      this.huoqulist(this.fenleixz, e);
    },
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;

      return dateStr.substring(0, length);
    },
    fanye: function fanye(e) {
      console.log(e);
      this.issum = e;
      this.huoqulist(this.fenleixz, this.xuanzhong);
    },
    huoqulist: function huoqulist(fenleixz, xuanzhong, key) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/yylist/scode/' + fenleixz + '/sum/' + this.issum + '?title=' + xuanzhong + '&key=' + key, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      }).then(function (response) {
        console.log(response.data.data);
        _this2.prductlist = response.data.data;
        _this2.countsum = response.data.tourl;
      }).catch(function (error) {
        console.error('当前网络环境异常!', error);
      });
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/24', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      console.log(response.data.data);
      _this.aboutinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    truncatecontent: function truncatecontent(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

      return dateStr.substring(0, length);
    },
    stringToArray: function stringToArray(str) {
      return str.split(',');
    },
    stringToArrayshu: function stringToArrayshu(str) {
      return str.split('|');
    },
    truncatecontentb: function truncatecontentb(dateStr) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return dateStr.substring(4, length);
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      huobanlist: [{
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }, {
        ico: '',
        id: '',
        title: ''
      }],
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      messtel: '',
      messname: '',
      messtitle: '',
      thisid: '',
      newsinfo: [],
      hbname: 'CONTACTS',
      newurl: 'https://naduapi.jurenkeji.com.cn'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.thisid = this.$route.query.id;
    if (this.$route.query.name) {
      this.hbname = this.$route.query.name;
    }

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.qiyeinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.zhandianinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.daohanglist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/' + this.thisid, {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.newsinfo = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/29/num/20/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    }).then(function (response) {
      _this.huobanlist = response.data.data;
    }).catch(function (error) {
      console.error('当前网络环境异常!', error);
    });
  },

  methods: {
    buttonmess: function buttonmess() {
      var _this2 = this;

      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        }).then(function (response) {
          alert('留言提交成功!');
          _this2.messname = '';
          _this2.messtel = '';
          _this2.messtitle = '';
        }).catch(function (error) {
          console.error('当前网络环境异常!', error);
        });
      } else {
        alert('内容不能为空');
        return;
      }
    }
  }
});

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA5NJREFUWEe9l1noVVUUxn/fQyQ02gRlNlMojU9pE83RSxCVUCFoNlBvUViiaPQgmNZDPVRYWRAVSVC9VJQIBgURNCo2kP+kwSIapB7y5Wuvv/tctqfzv2ffy78WXO69e3977W+vtc7+1hGVZvtqYCEwBzgSOAr4E9gF/AQ8D7wtaWely0mYhoFtHw3cAdycNjil0vHrwKOSNtXgpyRg+wHgNuCYlqM9wA+J2I/AwcDs/N3e76kUoXsl/TGMSCcB25uBi4uFcZoXgfclbWs7tH0sMB+INC0u5ieAayR9NhWJfxFwOnoLHKd4uCacgbF9A7ASOL1Yc7Kkb7p87EMg5fzJFN7bC+ACSRtrN29wto8AXgIuy2ORsrld6RgQyDlf1TiRNLRAa0jZXgMszdhXJF3fXje5Sa72D4uCO1fSBzWb9GFsv5lq56qMWyLpmXJNQyAqvjn9SDmvIBBpeCfjvki/L5D0yyDSOQI7gBOATZIu73M66rztdcA9ed1dkh4fEMhV+3IeuFPSE6Nu0Ie3fRqwvasWZDs2j0cn7BxJH/c5HGfe9pYU4QuB3yQdVkbgI+BsYI+k/cdxXrPG9jJgdcbOlPR7/I4IfAfMAiYknVjjbByM7UXAhrz2VElfNQTibt8vX7PnjeO8Zo3tK9N1/VbGni/pvYbAr8DMVAdbJZXXZ43fakyr2AdXc6QgxCU0frekQ6o9jgi0fXdSzUeAvyXNKIuwVL7ZkqImpt1svwDcCHwiKYp+0iICS4DQ7rCxxKePre2DUm/xPRDfG5OkLygJHJc0/Ns8sCG1VLf0ORx1vgh/LF0j6f4Bgfhh+7VoHP6LKNg+HvgcOBD4C5iXVDH+701BJlAKRkxeUgrGqCcu8S01XC1peTlf9gPrgVvz5LSIku2Q4ZDjsB2STmofpiQQj2DoQKhi2EOS7hv39LbPyv4aF9em6n91SgI5FWcAnxaguLnW1rbY2cfhQIQ5nvvSlkpaO5RAdhBherfVjkdTul5SNBSdZvtQ4CbgQSBIdNliSc921kA5aDvS8TRwXctLEHsjvxNEoxm4aMkvAq5I0TqgwG/NTciZkc5ifJ+7pu/NKO6EaCqjoai13cAKSY81C1pKGMMDEr2db26xo2GJR/XSLFwlmVDTL9PrW8hrfCJVX7fZtsRoQKKXQIejyHW8nMbn567NhtRJHKRp//aSqI3rdOFakZj43wnkJy0iEYX53D9j8DzbNMOhtwAAAABJRU5ErkJggg=="

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(71)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)
__webpack_require__(70)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(67)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(108),
  /* scopeId */
  "data-v-68ad4c8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(65)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(66)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(63)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(68)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(72)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "map-area section-padding hezuo_section1",
    staticStyle: {
      "height": "800px"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v(_vm._s(_vm.hbname))])])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding8"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "donghuasun hezuokuandu",
    staticStyle: {
      "width": "100%",
      "height": "200px",
      "border-bottom": "1px solid #ccc",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "600",
      "color": "#666666"
    }
  }, [_vm._v("战略合作伙伴 · "), _c('span', {
    staticStyle: {
      "color": "#44BCB9"
    }
  }, [_vm._v(_vm._s(_vm.newsinfo.title))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("• " + _vm._s(_vm.newsinfo.date))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("浏览量：" + _vm._s(_vm.newsinfo.visits))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "auto",
      "margin-top": "40px",
      "line-height": "40px",
      "display": "flex"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.newsinfo.content)
    }
  }), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br')])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section-padding8 section"
  }, [_c('div', {
    staticClass: "container ipahzhb"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tablea"
  }, _vm._l((_vm.huobanlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xintablea"
    }, [_c('a', {
      attrs: {
        "href": '/huoban?id=' + item.id + '&name=PARTNERS',
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "donghuasunfadeIn",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.6s"
      },
      attrs: {
        "src": _vm.newurl + item['ico']
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "40px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding hezuo_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("PARTNERS")])]), _vm._v(" "), _c('div', {
    staticClass: "animate bounce animated",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/shubiao.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donghuasun hezuokuandu",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "30px",
      "color": "#44BCB9"
    }
  }, [_vm._v("PARTNERS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#666666"
    }
  }, [_vm._v("战略合作伙伴")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.3s"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "col-lg-8 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "110px",
      "line-height": "60px",
      "border-bottom": "1px solid #cccccc"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.aboutinfo.title))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6 col-sm-6"
  }, [_c('ul', [_c('li', [_vm._v("• " + _vm._s(_vm.aboutinfo.date))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px !important",
      "position": "absolute",
      "right": "10%",
      "cursor": "pointer"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666666"
    }
  }, [_vm._v("浏览量：" + _vm._s(_vm.aboutinfo.visits))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap",
    staticStyle: {
      "margin-top": "50px",
      "line-height": "30px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 sidebar mt-5 mt-lg-0"
  }, [_c('div', {
    staticClass: "single-widget recent-posts-widget",
    staticStyle: {
      "border": "0px",
      "background": "#f7f8fc"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("拿度推荐")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list"
  }, _vm._l((_vm.tuijianlist), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "width": "100%",
        "height": "250px",
        "border-bottom": "1px solid #cccccc",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.waiurl + '/jiejueinfo?id=' + item.contentid
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      },
      attrs: {
        "src": _vm.newurl + item.ico
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "50px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("• " + _vm._s(item.date))])])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding fangan_section1 section",
    staticStyle: {
      "height": "960px"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "color": "#e40230",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_vm._v("SOLUTION")])])])
}]}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page yincang"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container header912"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "diannao-sous"
  }, [_c('img', {
    staticStyle: {
      "width": "18px",
      "margin-top": "25px",
      "display": "inline-block",
      "cursor": "pointer"
    },
    attrs: {
      "src": __webpack_require__(77)
    },
    on: {
      "click": _vm.toggleVisibility
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "custom-navbar sandaogang",
    on: {
      "click": function($event) {
        _vm.isVisibleb = _vm.flase
      }
    }
  }, [_c('span', {
    staticStyle: {
      "height": "2px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "height": "1px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "height": "2px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', [(!_vm.isVisible) ? _c('div', {
    staticClass: "custom-navbarc",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "rgb(0 0 0 / 8%)",
      "position": "fixed",
      "z-index": "-4",
      "left": "0px",
      "bottom": "0px"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.daohanglist), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": item.gnote
      },
      nativeOn: {
        "click": function($event) {
          return _vm.reloadPage.apply(null, arguments)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.son.length > 0) ? _c('ul', {
      staticClass: "sub-menu"
    }, [_c('div', {
      staticClass: "toubu_ziti2",
      staticStyle: {
        "color": "#FFFFFF",
        "font-size": "30px"
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + " / "), _c('span', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "500"
      }
    }, [_vm._v(_vm._s(item.filename))]), _vm._v(" "), _c('p', {
      staticClass: "toubu_ziti1",
      staticStyle: {
        "font-size": "16px",
        "line-height": "50px",
        "color": "#ffffffad"
      }
    }, [_vm._v("\n                          专注于工业自动化测控领域的应用产品开发与技术服务\n                        ")])]), _vm._v(" "), _vm._l((item.son), function(itema, indexa) {
      return _c('li', {
        key: indexa
      }, [_c('router-link', {
        attrs: {
          "to": itema.gnote
        },
        nativeOn: {
          "click": function($event) {
            return _vm.reloadPage.apply(null, arguments)
          }
        }
      }, [_vm._v(_vm._s(itema.name))])], 1)
    }), _vm._v(" "), _vm._m(3, true)], 2) : _vm._e()], 1)
  })], 2), _vm._v(" "), (_vm.isVisibleb) ? _c('div', {
    staticClass: "diannao-sous-kuang"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyValue),
      expression: "keyValue"
    }],
    staticClass: "inputValue",
    staticStyle: {
      "background-color": "transparent",
      "border": "solid 1px white",
      "font-size": "14px",
      "color": "white",
      "height": "36px",
      "padding": "6px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.keyValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "login",
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "line-height": "35px",
      "padding": "0px 10px",
      "border-radius": "5px",
      "background": "#007bff"
    },
    attrs: {
      "to": {
        path: '/yingyong',
        query: {
          key: _vm.keyValue
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                        搜索\n                      ")])], 1) : _vm._e()])])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "footer-area section-padding"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "22px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(6)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_vm._v("拿度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-area"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/logoc.png",
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("网站首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toubu_tubiao",
    staticStyle: {
      "float": "right",
      "top": "100px",
      "position": "absolute",
      "right": "10%"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/bailogo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "map-area section-padding section product_section_new",
    staticStyle: {
      "height": "900px"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("产品中心")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_vm._v("PRODUCTS")]), _vm._v(" "), _c('P', {
    staticClass: "p3 animate fadeInUp animated jjfangan_zt4",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "chanpin"
  }, [_vm._v("\n          拿度磁致伸缩位移/液位传感器,DIMETIX激光测距传感器具有绝对位移测量、精度高、永不磨损、坚固耐用、运行可靠、耐严苛环境等优点，广泛应用于液压伺服、冶金制造，工控机械、石化、水利、灌装、风电光伏等。")])])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "jobs-area section-padding2"
  }, [_c('div', {
    staticClass: "product_sun_tab"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sun_tab_fu"
  }, [_c('div', {
    staticClass: "sun_tab_fu1"
  }, [_c('div', {
    staticClass: "sun_tab_fu2 animate fadeInLeft animated",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.1s"
    }
  }, _vm._l((_vm.chanpintab.son), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "suntab_xun",
      on: {
        "mouseover": function($event) {
          return _vm.handleMouseOver(item.scode)
        },
        "mouseleave": function($event) {
          return _vm.handleMouseLeave(item.scode)
        }
      }
    }, [(item.scode == _vm.itemscode) ? _c('div', {
      staticClass: "sun_xuna xuanzhong"
    }) : _c('div', {
      staticClass: "sun_xuna"
    }), _vm._v(" "), (item.scode == _vm.itemscode) ? _c('div', {
      staticClass: "sun_xunb"
    }, [(item.scode == _vm.scodein) ? _c('p', {
      staticStyle: {
        "font-weight": "600",
        "color": "#4bbfbc"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('p', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "buxianshichanpin",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.subname))])]) : _c('div', {
      staticClass: "sun_xunb"
    }, [_c('p', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "buxianshichanpin",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.subname))])]), _vm._v(" "), (item.scode == _vm.itemscode) ? _c('div', {
      staticClass: "sun_xunc xuanzhonga"
    }) : _c('div', {
      staticClass: "sun_xunc"
    })])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "chanpin_s1"
  }, _vm._l((_vm.pubiclist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s1_01 animate zoomIn animated",
      staticStyle: {
        "animation-duration": "0.6s",
        "animation-delay": "0.1s"
      }
    }, [_c('a', {
      attrs: {
        "href": '/chanpin?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a"
    }, [_c('div', {
      staticClass: "chanpin_s101_a1"
    }, [_c('img', {
      staticStyle: {
        "height": "auto"
      },
      attrs: {
        "src": _vm.newurl + item.ico
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "chanpin_s101_a2"
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yingyongfenlei zengjiaxin"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "position": "relative"
    }
  }, [_vm._v("右滑查看更多分类->")])])
}]}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2 toubugaodu",
    staticStyle: {
      "height": "400px",
      "background": "url('../static/assets/images/bannerc.jpg') no-repeat",
      "background-size": "100% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_tab"
  }, [_c('router-link', {
    staticClass: "about_tab_jj",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_wh",
    attrs: {
      "to": "/wenhua"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_jg",
    staticStyle: {
      "background": "#0473db",
      "color": "#ffffff"
    },
    attrs: {
      "to": "/jiagou"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业架构")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_zr",
    attrs: {
      "to": "/zeren"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("认证体系")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_sm",
    attrs: {
      "to": "/shengming"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("版权声明")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2 jiagou_section1"
  }, [_c('div', {
    staticClass: "container jiagouimg",
    staticStyle: {
      "padding-top": "100px",
      "padding-bottom": "100px"
    }
  }, [_c('p', {
    staticClass: "wow zoomIn animated",
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pc_201411 wow zoomIn animated",
    attrs: {
      "src": _vm.newurl + _vm.aboutinfo.pics
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "wap_201411 wow zoomIn animated",
    attrs: {
      "src": _vm.newurl + _vm.aboutinfo.enclosure
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row toubugaoduzt",
    staticStyle: {
      "height": "400px",
      "line-height": "400px",
      "color": "#ffffff",
      "font-size": "45px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticStyle: {
      "font-style": "initial"
    }
  }, [_vm._v("关于我们")])])])])])
}]}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container fuwuzhichi_sun1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sun_left",
    attrs: {
      "id": "toggleDivzzy"
    }
  }, _vm._l((_vm.tablelist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "nei01"
    }, [_c('div', {
      staticClass: "neititle"
    }, [_vm._v(_vm._s(item.name) + "\n              "), _c('img', {
      attrs: {
        "width": "16px",
        "src": __webpack_require__(78)
      }
    })]), _vm._v(" "), _c('ul', _vm._l((item.son), function(itema, indexa) {
      return _c('li', {
        key: indexa,
        on: {
          "click": function($event) {
            return _vm.fuwuinfoanb(itema.scode)
          }
        }
      }, [_vm._v(_vm._s(itema.name))])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sun_left diannaolist"
  }, _vm._l((_vm.tablelist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "nei01"
    }, [_c('div', {
      staticClass: "neititle"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', _vm._l((item.son), function(itema, indexa) {
      return _c('li', {
        key: indexa,
        on: {
          "click": function($event) {
            return _vm.fuwuinfoan(itema.scode)
          }
        }
      }, [_vm._v(_vm._s(itema.name))])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sun_right",
    attrs: {
      "id": "younei"
    }
  }, [_c('div', {
    staticClass: "nei01"
  }, [_c('div', {
    staticClass: "neititle"
  }, [_vm._v("当前栏目：" + _vm._s(_vm.fuwuname))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "table",
      "border-radius": "15px",
      "border": "2px solid #cccccc",
      "background": "#ffffff",
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin-left": "5%",
      "padding-top": "20px",
      "padding-bottom": "20px",
      "line-height": "40px",
      "float": "left"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.fuwuinfo.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "90%",
      "margin-left": "5%",
      "padding-top": "20px",
      "padding-bottom": "20px",
      "line-height": "40px",
      "float": "left",
      "color": "rgb(156 156 156)"
    }
  }, [_c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "16px"
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    staticStyle: {
      "color": "#44bcb9"
    }
  }), _vm._v("\n                " + _vm._s(_vm.fuwuinfo.visits) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.fuwuinfo.date) + " ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding fuwuzhichi_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated news_sun_ziti1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("服务与支持")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated news_sun_ziti2",
    staticStyle: {
      "color": "#e40230",
      "font-weight": "500",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_vm._v("\n          SERVICE AND SUPPORT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle_phone",
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    staticStyle: {
      "background": "none",
      "border": "none",
      "padding": "4px 6px",
      "font-size": "16px",
      "color": "#000",
      "width": "40%",
      "font-weight": "600",
      "/*     height": "70px",
      "*/\n    margin-right": "30px",
      "float": "left",
      "right": "14px",
      "height": "40px",
      "/*     z-index": "100",
      "*/\n/*     border-radius": "57px"
    },
    attrs: {
      "id": "toggleButton"
    }
  }, [_vm._v("点击选择栏目")])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_c('section', {
    staticClass: "banner-area section index_banner_box"
  }, [_c('div', {
    staticClass: "banner_swiper swiper-container swiper-container-fade swiper-container-initialized swiper-container-horizontal"
  }, [_c('div', {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "transition-duration": "0ms"
    }
  }, _vm._l((_vm.bannerlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide",
      staticStyle: {
        "width": "1903px",
        "opacity": "1",
        "transition-duration": "0ms",
        "margin-right": "0px !important"
      },
      attrs: {
        "data-swiper-slide-index": index
      }
    }, [_c('div', {
      staticClass: "img_box"
    }, [_c('img', {
      staticClass: "ani",
      staticStyle: {
        "visibility": "hidden"
      },
      attrs: {
        "src": item.pic,
        "swiper-animate-effect": "toSmall",
        "swiper-animate-duration": "5s",
        "swiper-animate-delay": "0s",
        "swiper-animate-style-cache": "visibility: hidden;"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text_box"
    }, [_c('h3', {
      staticClass: "ani fadeInUp80 animated",
      staticStyle: {
        "visibility": "visible",
        "animation-duration": "1s",
        "-webkit-animation-duration": "1s",
        "animation-delay": "0s",
        "-webkit-animation-delay": "0s"
      },
      attrs: {
        "swiper-animate-effect": "fadeInUp80",
        "swiper-animate-duration": "1s",
        "swiper-animate-delay": "0s",
        "swiper-animate-style-cache": "visibility: hidden;"
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")]), _vm._v(" "), _c('h2', {
      staticClass: "ani fadeInUp80 animated",
      staticStyle: {
        "visibility": "visible",
        "animation-duration": "1s",
        "-webkit-animation-duration": "1s",
        "animation-delay": "0s",
        "-webkit-animation-delay": "0s"
      },
      attrs: {
        "swiper-animate-effect": "fadeInUp80",
        "swiper-animate-duration": "1s",
        "swiper-animate-delay": "0s",
        "swiper-animate-style-cache": "visibility: hidden;"
      }
    }, [_vm._v("\n                " + _vm._s(item.subtitle) + "\n              ")])])])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "swiper-notification",
    attrs: {
      "aria-live": "assertive",
      "aria-atomic": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner_thumber swiper-container-initialized swiper-container-horizontal swiper-container-thumbs"
  }, [_c('div', {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "transform": "translate3d(0px, 0px, 0px)",
      "transition-duration": "0ms"
    }
  }, _vm._l((_vm.bannerlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('span'), _vm._v(" "), _c('p', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "xz"
    }, [_c('div', {
      staticClass: "progressb"
    }, [_c('div', {
      staticClass: "circle",
      attrs: {
        "data-name": "CSS Skill",
        "data-percent": "100%"
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "-10 -10 220 220"
      }
    }, [_c('g', {
      attrs: {
        "fill": "none",
        "stroke-width": "6",
        "transform": "translate(100,100)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M 0,-100 A 100,100 0 0,1 86.6,-50 A 100,100 0 0,1 86.6,50 A 100,100 0 0,1 0,100 A 100,100 0 0,1 -86.6,50 A 100,100 0 0,1 -86.6,-50 A 100,100 0 0,1 0,-100"
      }
    })])]), _vm._v(" "), _c('svg', {
      attrs: {
        "viewBox": "-10 -10 220 220"
      }
    }, [_c('path', {
      attrs: {
        "d": "M200,100 C200,44.771525 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z",
        "stroke-dashoffset": "629"
      }
    })])])]), _vm._v(" "), _vm._m(0, true)])])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "swiper-notification",
    attrs: {
      "aria-live": "assertive",
      "aria-atomic": "true"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "section feature-area section-padding2",
    staticStyle: {
      "background": "url('../static/assets/images/producis.png') no-repeat"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container homecp912 sun913pc"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.lanmulist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 texiao donghuasun",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.3s",
        "visibility": "visible",
        "max-width": "19%"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/category?id=' + item.scode,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "single-feature mb-4 mb-lg-0"
    }, [_c('h4', {
      staticStyle: {
        "height": "45px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.subname))]), _vm._v(" "), _c('div', {
      staticClass: "xincpfm"
    }, [_c('img', {
      staticClass: "shrinkable-image",
      attrs: {
        "src": _vm.newurl + item.ico,
        "alt": "Your Image"
      }
    })])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sun913sj",
    staticStyle: {
      "max-width": "100%",
      "height": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "homecp912",
    staticStyle: {
      "max-width": "100%",
      "height": "85%",
      "position": "absolute",
      "width": "100%",
      "bottom": "0px",
      "background": "url('../static/assets/images/beijzz.png') no-repeat bottom",
      "background-size": "100%"
    }
  }, _vm._l((_vm.lanmulist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 texiao donghuasun",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.3s",
        "width": "45%",
        "margin-left": "3%",
        "float": "left"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/category?id=' + item.scode,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "single-feature mb-4 mb-lg-0",
      staticStyle: {
        "height": "90%",
        "padding": "0px",
        "border-radius": "6px"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "140px",
        "text-align": "center",
        "bottom": "15%",
        "right": "0px"
      }
    }, [_c('img', {
      staticClass: "shrinkable-image",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.newurl + item.ico,
        "alt": "Your Image"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "line",
      staticStyle: {
        "width": "100%"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "60%",
        "line-height": "40px",
        "font-size": "16px",
        "text-align": "center"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.truncatechanpin(item.name)) + "\n                ")])])])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "category-area section-padding section section-padding99",
    staticStyle: {
      "background": "url('../static/assets/images/solve_bg.jpg') no-repeat center"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sun913sj",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "visibility": "visible"
    }
  }, [_c('ul', [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[2].id,
      "target": "_blank"
    }
  }, [_c('li', {
    staticClass: "idx_falist1",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg1.jpg')",
      "left": "0px",
      "height": "140px",
      "background-size": "100%",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "line-height": "50px",
      "color": "#fff",
      "padding": "50px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.fanganlist[2]['title']) + "\n              ")])])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[1].id,
      "target": "_blank"
    }
  }, [_c('li', {
    staticClass: "idx_falist2",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg2.jpg')",
      "left": "0px",
      "height": "140px",
      "background-size": "100%",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "line-height": "50px",
      "color": "#fff",
      "padding": "50px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.fanganlist[1]['title']) + "\n              ")])])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[0].id,
      "target": "_blank"
    }
  }, [_c('li', {
    staticClass: "idx_falist3 active",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg3.jpg')",
      "left": "0px",
      "height": "140px",
      "background-size": "100%",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "line-height": "50px",
      "color": "#fff",
      "padding": "50px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.fanganlist[0]['title']) + "\n              ")])])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "idx_fa animate fadeInUp animated donghuasun sun913pc",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "visibility": "visible"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "idx_falist1",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg1.jpg')",
      "left": "0px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[2].id,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "idxfa_title flexrow"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[2]['title']))])]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc animate fadeIn animated",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeIn",
      "data-duration": "1.5s",
      "data-delay": "0.1s"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[2]['title']))]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc_item"
  }, [_c('p', [_vm._v(_vm._s(_vm.fanganlist[2]['description']))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("了解更多 >")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "idx_falist2",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg2.jpg')",
      "left": "25%"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[1].id,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "idxfa_title flexrow"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[1]['title']))])]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc animate fadeIn animated",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeIn",
      "data-duration": "1.5s",
      "data-delay": "0.1s"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[1]['title']))]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc_item"
  }, [_c('p', [_vm._v(_vm._s(_vm.fanganlist[1]['description']))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("了解更多 >")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "idx_falist3 active",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg3.jpg')",
      "left": "50%"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[0].id,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "idxfa_title flexrow"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[0]['title']))])]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc animate fadeIn animated",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeIn",
      "data-duration": "1.5s",
      "data-delay": "0.1s"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[0]['title']))]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc_item"
  }, [_c('p', [_vm._v(_vm._s(_vm.fanganlist[0]['description']))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("了解更多 >")])])])])])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('section', {
    staticClass: "jobs-area section-padding3 section"
  }, [_c('div', {
    staticClass: "container homecontainer",
    staticStyle: {
      "position": "absolute",
      "top": "15%",
      "margin-left": "10%"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "donghuaLeft",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.5s",
      "width": "50%",
      "float": "left",
      "padding-right": "5%"
    }
  }, [_c('p', {
    staticClass: "homeaboutsj",
    staticStyle: {
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("专注于工业自动化测控领域的应用产品开发与技术服务")]), _vm._v(" "), _c('p', {
    staticClass: "hongaboutsja",
    staticStyle: {
      "color": "#666666",
      "line-height": "34px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.aboutinfo.description) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "donghuaRight llsunz",
    staticStyle: {
      "width": "40%",
      "float": "left",
      "animation-duration": "1s",
      "animation-delay": "1s"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.newurl + _vm.aboutinfo.ico
    }
  })])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding4 section",
    staticStyle: {
      "width": "100% !important"
    }
  }, [_c('div', {
    staticClass: "sun"
  }, [_c('div', {
    staticClass: "suna"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "suna_b donghuasunfadeIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/yingyong"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.hangyelist[1]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "kongnidiv",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.hangyelist[1]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.hangyelist[1]['description']))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb"
  }, [_c('div', {
    staticClass: "sunb_a donghuasunfadeIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/yingyong"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.hangyelist[3]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "kongnidiv",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.hangyelist[3]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.hangyelist[3]['description']))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb_b donghuasunfadeIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/yingyong"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.hangyelist[0]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "kongnidiv",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.hangyelist[0]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.hangyelist[0]['description']))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunc"
  }, [_c('div', {
    staticClass: "idx_pros donghuasunfadeIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.6s"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/yingyong"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.hangyelist[2]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "kongnidiv",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.hangyelist[2]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.hangyelist[2]['description']))])])])])])])])])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('section', {
    staticClass: "section-padding5 section",
    staticStyle: {
      "width": "100% !important"
    }
  }, [_c('div', {
    staticClass: "sun"
  }, [_c('div', {
    staticClass: "suna"
  }, [_c('div', {
    staticClass: "idx_pros donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.1s"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[0]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "jsfw_1108",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "center",
      "line-height": "46px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "500"
    }
  }, [_vm._v("TECHNICAL SERVICE")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9"
    }
  }, [_vm._v("技术服务")]), _vm._v(" "), _c('p', {
    staticClass: "jsfw_new_zt",
    staticStyle: {
      "font-size": "16px",
      "margin-top": "100px"
    }
  }, [_vm._v(_vm._s(_vm.fuwulist[0]['description']) + "\n                      ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb"
  }, [_c('div', {
    staticClass: "sunb_a"
  }, [_c('div', {
    staticClass: "sunb_a_a donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[4]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.fuwulist[4]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.fuwulist[4]['description']))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb_a_b donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.7s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[3]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.fuwulist[3]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.fuwulist[3]['description']))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb_b"
  }, [_c('div', {
    staticClass: "sunb_b_a donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "1.1s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[2]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.fuwulist[2]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.fuwulist[2]['description']))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb_b_b donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "1.4s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[1]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.fuwulist[1]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.fuwulist[1]['description']))])])])])])])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding7 section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row donghuaLeft",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.6s"
    }
  }, _vm._l((_vm.newslist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 col-md-6",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/blogDetails?id=' + item.id + '&cid=' + item.scode,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "single-news mb-5 mb-lg-0 qudiaodibu"
    }, [_c('div', {
      staticClass: "news-img news-img1",
      style: ('background-image: url(' + _vm.newurl + item.ico + '); left: 50%;')
    }), _vm._v(" "), _c('div', {
      staticClass: "news-tag qudiaomarg",
      staticStyle: {
        "padding": "0px 20px"
      }
    }, [_c('ul', {
      staticClass: "my-4 qudiaomarg",
      staticStyle: {
        "font-size": "20px"
      }
    }, [_c('li', [_c('h5', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-o"
    }), _vm._v(_vm._s(_vm.truncateDate(item.date)))])]), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('li', [_c('h5', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.sortname))])])])]), _vm._v(" "), _c('div', {
      staticClass: "news-title",
      staticStyle: {
        "padding": "0px 20px"
      }
    }, [_c('h4', {
      staticClass: "bianhuaduoduan",
      staticStyle: {
        "line-height": "28px"
      }
    }, [_c('a', {
      staticClass: "xinwen",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm.truncatetitle(item.title)) + "..")])]), _vm._v(" "), _c('p', {
      staticClass: "buxianshi",
      staticStyle: {
        "font-size": "16px",
        "color": "#666666"
      }
    }, [_vm._v(_vm._s(_vm.truncatecontent(item.description)) + " ...\n                  ")]), _vm._v(" "), _c('p', {
      staticClass: "buxianshi",
      staticStyle: {
        "font-size": "16px",
        "color": "#666666",
        "margin-top": "50px"
      }
    }, [_vm._v("了解更多 >>")])])])])])
  }), 0), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "24px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "2%"
    }
  }, [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(15)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jt"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/jz.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wow fadeInUp sun913pc",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center",
      "position": "absolute",
      "top": "0px"
    }
  }, [_c('p', {
    staticClass: "phonecpzt",
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9",
      "margin-top": "150px"
    }
  }, [_vm._v("PRODUCTS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("产品中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "15%",
      "text-align": "center",
      "position": "absolute",
      "top": "0px"
    }
  }, [_c('p', {
    staticClass: "phonecpzt",
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9",
      "margin-top": "150px"
    }
  }, [_vm._v("PRODUCTS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("产品中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container donghuasun"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9"
    }
  }, [_vm._v("SOLUTIONS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#ffffff"
    }
  }, [_vm._v("解决方案")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idx_sun"
  }, [_c('span', {
    staticClass: "sun_xza",
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_vm._v("●")]), _vm._v(" "), _c('span', {
    staticClass: "sun_xzb",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("●")]), _vm._v(" "), _c('span', {
    staticClass: "sun_xzc",
    staticStyle: {
      "padding-left": "60px"
    }
  }, [_vm._v("●")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idx_sun"
  }, [_c('span', {
    staticClass: "sun_xza",
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_vm._v("●")]), _vm._v(" "), _c('span', {
    staticClass: "sun_xzb",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("●")]), _vm._v(" "), _c('span', {
    staticClass: "sun_xzc",
    staticStyle: {
      "padding-left": "60px"
    }
  }, [_vm._v("●")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donghuasun about_sun",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center",
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9",
      "font-weight": "bold"
    }
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("公司简介")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-job-btn mt-5 text-center donghuasunfadeIn liaojiesunbbc",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1.5s"
    }
  }, [_c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "/about",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suna_a donghuaDown",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "ipahyyy",
    staticStyle: {
      "width": "40%",
      "height": "50%",
      "text-align": "right",
      "margin-left": "15%"
    }
  }, [_c('p', {
    staticClass: "hyyy_new_ywzt",
    staticStyle: {
      "font-size": "24px",
      "color": "#ffffff",
      "font-weight": "500",
      "margin-left": "-4px"
    }
  }, [_vm._v("\n                  INDUSTRIES")]), _vm._v(" "), _c('p', {
    staticClass: "hyyy_new_zt",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("行业应用")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-padding6 section"
  }, [_c('div', {
    staticClass: "container donghuasun",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9"
    }
  }, [_vm._v("ADVANTAGES")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#666666"
    }
  }, [_vm._v("拿度优势")])])]), _vm._v(" "), _c('div', {
    staticClass: "homeyoushi",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "advantage_num donghuaIn",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "1s"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "donghuasun",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.4s"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage01.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', [_vm._v("6")]), _c('i', [_vm._v("大")])]), _vm._v(" "), _c('p', [_vm._v("主要业务板块，"), _c('br'), _vm._v("\n                  磁致伸缩位移传感器、激光传感器")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.7s"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage02.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', [_vm._v("10")]), _c('i', [_vm._v("年")])]), _vm._v(" "), _c('p', [_vm._v("十年以上的行业经验，"), _c('br'), _vm._v("\n                  强大的传感器研发、设计和测试工程师团队")])])]), _vm._v(" "), _c('li', {
    staticClass: "donghuasun",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.9s"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage03.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', [_vm._v("60")]), _c('i', [_vm._v("种")])]), _vm._v(" "), _c('p', [_vm._v("位移传感器产品，"), _c('br'), _vm._v("\n                  技术上追求“度”，做事上立本于“度”")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row donghuasun",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top xinwen_biaoti",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#44BCB9",
      "font-weight": "500",
      "font-size": "24px"
    }
  }, [_vm._v("NEWS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "24px"
    }
  }, [_vm._v("新闻资讯")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "separator mx-2"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donghuaRight",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "text-align": "center",
      "line-height": "100px",
      "animation-duration": "1s",
      "animation-delay": "0.6s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/blog?id=15",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "download-btn"
  }, [_vm._v("\n              查看全部新闻 +\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.3s"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "sample-text-area",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("公司业绩")]), _vm._v(" "), _c('p', {
    staticClass: "sample-text"
  }, [_vm._v("\n         主要有生化试剂和临床化学试剂、环境科学用试剂、光学和电子工业用试剂；军用和民用发光材料；电影和照相用感光材料；印刷用化学品；胶粘剂以及塑料助剂等。建厂以来累计生产近4000个品种。\n         北京化工厂还是中国化学试剂科技，并受国家标准局的委托，负责组织制定化学试剂的国家标准。\n         汇翔化工有限公司成立于2017年09月25日，注册地位于河南省获嘉县照镜镇楼村工业园区纬三路西段路北，占地面积16500㎡。技术研究依托于河南师范大学化工学院，始终本着\"质量为本，诚信务实，勤奋进取，服务至上\"的服务理念，并且实际运用于管理之中。新乡市汇翔化工有限公司的诚信、实力和产品质量获得业界的认可。\n         经营范围包括溴丙烷、溴化钠、硫酸氢钠水溶液等产品销售！欢迎各界朋友莅临参观、指导和业务洽谈。")])])]), _vm._v(" "), _c('div', {
    staticClass: "whole-wrap",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("产品中心")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 mt-sm-20 left-align-p"
  }, [_c('p', [_vm._v("碳酸二甲酯，是一种有机化合物，化学式为C3H6O3，是一种低毒、环保性能优异、用途广泛的化工原料，是一种重要的有机合成中间体，分子结构中含有羰基、甲基和甲氧基等官能团，具有多种反应性能，在生产中具有使用安全、方便、污染少、容易运输等特点。\n\n  中文名：碳酸二甲酯 外文名：Dimethyl carbonate，DMC\n\n  化学式：C3H6O3 分子量：90.078\n\n  熔  点：0.5 ℃ 沸  点：90 ℃\n\n  水溶性：不溶 密  度：1.07 g/cm³\n\n  外  观：无色液体，有芳香气味 闪   点：17 ℃(OC)\n\n  安全性描述：S16；S9 危险性符号：F\n\n  危险性描述：R11UN 危险货物编号：1161")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border text-right"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("尿素")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('p', {
    staticClass: "text-right"
  }, [_vm._v("尿素是一种酰胺态有机态氮肥，其分子式为CO(NH2)2，是含氮量最高的固体氮肥。\n  本品为白色半透明颗粒，属中性肥料，易溶于水，在20℃时，100克水能溶解尿素100克，在常温下吸湿性不大。尿素的扩散性很强，小部分能以分子态被植物吸收。本品适用于各种土壤和作物，可以用于基肥，种肥和根外追肥。尿素除大量用于农业外，它还是树脂、塑料、医药、食品等工业的原料，又是家畜，淡水养殖的饲料。\n  本品执行标准为GB/T 2440-2017。昊源公司现已成为浙江，江苏，福建等省的多家胶合板厂生产厂家长期稳定的工业级尿素供应企业，产品质量得到他们的高度认可。")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("产品技术")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("碳酸二甲酯")]), _vm._v(" "), _c('p', [_vm._v("碳酸二甲酯，是一种有机化合物，化学式为C3H6O3，是一种低毒、环保性能优异、用途广泛的化工原料，是一种重要的有机合成中间体，分子结构中含有羰基、甲基和甲氧基等官能团，具有多种反应性能，在生产中具有使用安全、方便、污染少、容易运输等特点。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("乙酸叔丁酯")]), _vm._v(" "), _c('p', [_vm._v("醋酸叔丁酯是一种低毒性溶剂，被美国国家环保局（EPA）列为免除受限制的挥发性溶剂 （VOC-exempt）和非有害空气污染物（non-HAP）。醋酸叔丁酯对多种物质具有优异的溶解能力，如： 硝化纤维、丙烯酸、醇酸树脂、聚酯和聚気酯树脂等。醋酸叔丁酯可以替代多种有害空气污染物（HAP） 和挥发性有溶剂（VOC）,包括甲苯、二甲苯、酯类、酮类和碳氢化合物等。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("工业清洗剂")]), _vm._v(" "), _c('p', [_vm._v("作为一种溶剂型清洗剂，醋酸叔丁酯与一般的氯化溶剂和烃类溶剂同样具有广泛的溶解能力，而且作为非卤溶剂，不会对臭氧层造成破坏，可用于金属脱脂和特殊设备的清洁，例如航空、航天工业机械，精细机械设备等的清洗等。此外还能有效清除甲苯、被清洗矿物油和丙酮污染的土壤、锂基润滑脂等。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("产品介绍及应用")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('blockquote', {
    staticClass: "generic-blockquote"
  }, [_vm._v("\n                醋酸叔丁酯是一种低毒性溶剂，被美国国家环保局（EPA）列为免除受限制的挥发性溶剂 （VOC-exempt）和非有害空气污染物（non-HAP）。醋酸叔丁酯对多种物质具有优异的溶解能力，如： 硝化纤维、丙烯酸、醇酸树脂、聚酯和聚気酯树脂等。醋酸叔丁酯可以替代多种有害空气污染物（HAP） 和挥发性有溶剂（VOC）,包括甲苯、二甲苯、酯类、酮类和碳氢化合物等。\n\n  ♦涂料、油墨、粘合剂：醋酸叔丁酯在装饰和工业涂料，以及油墨、压敏胶、粘合剂等配方中，可替代VOC和HAP溶剂，它比丙酮和醋酸甲酯更加不易挥发和不易燃。醋酸叔丁酯在多种涂料体系中（例如，2K聚氨酯、醇酸树脂、丙烯酸树脂、硝基纤维、喷漆和烤漆等）与其他溶剂有着类似的挥发速度和溶解能力，例如甲乙酮、甲基异丁基酮、乙基、丙基醋酸酯和甲苯等。由于其优越的耐胺能力，也可以用于取代环氧聚酰胺涂料中的甲苯溶剂。\n\n  ♦工业清洗剂：作为一种溶剂型清洗剂，醋酸叔丁酯与一般的氯化溶剂和烃类溶剂同样具有广泛的溶解能力，而且作为非卤溶剂，不会对臭氧层造成破坏，可用于金属脱脂和特殊设备的清洁，例如航空、航天工业机械，精细机械设备等的清洗等。此外还能有效清除甲苯、被清洗矿物油和丙酮污染的土壤、锂基润滑脂等。\n\n  ♦电子行业：醋酸叔丁酯在半导体加工过程中也有一定的应用，在光刻胶配方中可用来替代其他溶剂，也可用于清洗电路板，除油和去除助焊剂。\n\n  ♦其他应用：农产品；纺织品：制药中间体等等。\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "title_color"
  }, [_vm._v("图片中心")]), _vm._v(" "), _c('div', {
    staticClass: "row gallery-item"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g1.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g1.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g2.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g2.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g3.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g3.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g4.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g4.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g5.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g5.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g6.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g6.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g7.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g7.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g8.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g8.jpg)"
    }
  })])])])])])])])
}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "contact-form lianxi_section2 section"
  }, [_c('div', {
    staticClass: "lianxibiao"
  }, [_c('div', {
    staticClass: "lianxibiao1"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "d-flex top-30 donghuasun",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s",
      "visibility": "visible",
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_c('p', {
    staticClass: "shoujino",
    domProps: {
      "innerHTML": _vm._s(_vm.lianxiwomen.content)
    }
  }), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex donghuasun lianxibuxians",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.8s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_c('p', {
    staticClass: "zxdh",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("咨询电话")]), _vm._v(" "), _c('p', {
    staticClass: "zxdh1",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.qiyeinfo.phone))])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "biaodan1 donghuaRight",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "biaodan2"
  }, [_vm._v("\n            联系我们\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "biaodan3"
  }, [_c('div', {
    staticClass: "left",
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    }
  }, [_c('p', [_c('label', [_vm._v("姓名：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    staticStyle: {
      "width": "100%",
      "border": "0px",
      "padding": "10px"
    },
    attrs: {
      "type": "messname",
      "placeholder": "请输入您的称呼",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '请输入您的称呼'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('label', [_vm._v("电话：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    staticStyle: {
      "width": "100%",
      "border": "0px",
      "padding": "10px"
    },
    attrs: {
      "type": "messtel",
      "placeholder": "请输入您的联系电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '请输入您的联系电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("内容：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    staticStyle: {
      "width": "100%",
      "border": "1px solid #eee",
      "padding": "10px",
      "height": "100px",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "messtitle",
      "name": "message",
      "cols": "20",
      "rows": "7",
      "placeholder": "请输入您的留言内容",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '请输入您的留言内容'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "margin-bottom": "30px",
      "background": "#e40230",
      "color": "#ffffff"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("提交")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "contact-form section-padding3 lianxi_section3 section"
  }, [_c('div', {
    staticClass: "lianxi_sun1"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "lianxi_sun3 donghuaRight",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.8s",
      "visibility": "visible",
      "z-index": "0"
    }
  }, [_c('p', {
    staticClass: "rencai",
    domProps: {
      "innerHTML": _vm._s(_vm.linian1.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lianxi_sun4 donghuaRight",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1.3s",
      "visibility": "visible"
    }
  }, [_c('p', {
    staticClass: "rencai",
    domProps: {
      "innerHTML": _vm._s(_vm.linian2.content)
    }
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('section', {
    staticClass: "contact-form section-padding3 lianxi_section5 section"
  }, [_c('div', {
    staticClass: "zpgw01"
  }, [_c('div', {
    staticClass: "zpgw01-1"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.zhaopin), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zpgw01-1-2 donghuasunfadeIn",
      staticStyle: {
        "cursor": "pointer",
        "animation-duration": "1s",
        "animation-delay": "0.8s",
        "visibility": "visible"
      },
      on: {
        "click": function($event) {
          return _vm.openPopup(item.content)
        }
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('p', {
      staticClass: "zhiyefazhan_02",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("招聘人数 : " + _vm._s(item.ext_zhaopinrenshu) + "人")]), _vm._v(" "), _c('p'), _c('div', {
      staticClass: "zp0112-1"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
      staticClass: "chchaziti_s",
      staticStyle: {
        "margin-top": "100px"
      }
    }, [_c('span', [_vm._v(_vm._s(item.ext_gongzuodidian))])])])
  }), _vm._v(" "), (_vm.showPopup) ? _c('div', {
    staticClass: "popup-container",
    on: {
      "click": _vm.guanbitc
    }
  }, [_c('div', {
    staticClass: "zuixintc_S",
    staticStyle: {
      "width": "50%",
      "text-align": "left",
      "background": "#fff",
      "padding": "20px",
      "border-radius": "10px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.zhaopininfo)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#E91E63",
      "cursor": "pointer",
      "padding": "10px 5px",
      "border-radius": "0px 5px 5px 0px",
      "color": "#fff"
    },
    on: {
      "click": _vm.guanbitc
    }
  }, [_vm._v("关闭")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "20px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(11)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_vm._v("拿度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding lianxi_section1 section",
    staticStyle: {
      "background-size": "auto 100% !important"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("CONTACT US")])]), _vm._v(" "), _c('div', {
    staticClass: "animate bounce animated",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/shubiao.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex donghuaDown",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.2s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_c('span', {
    staticClass: "llx1",
    staticStyle: {
      "border-bottom": "0px",
      "color": "#e40230"
    }
  }, [_vm._v("联系方式 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoujiok"
  }, [_c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  公司地址：\n                ")]), _c('div', {
    staticClass: "zzz123"
  }, [_vm._v("山东省烟台经济技术开发区珠江路32号3号楼")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  业务电话：\n                ")]), _c('div', {
    staticClass: "zzz123"
  }, [_vm._v("18562255186"), _c('br'), _vm._v("18596163696"), _c('br'), _vm._v("18562255176")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  公司传真：\n                ")]), _c('div', {
    staticClass: "zzz123"
  }, [_vm._v("0535-6936196")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  企业邮箱：\n                ")]), _c('div', {
    staticClass: "zzz123"
  }, [_vm._v("ytndkj@163.com   2141299192@qq.com")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  QQ         ：2141299192\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex donghuasun lianxibuxians",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.9s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_c('div', {
    staticClass: "image-containerc-lx"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera-lx"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb-lx"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lianxi_sun2"
  }, [_c('img', {
    staticClass: "donghuaLeft",
    staticStyle: {
      "height": "100%",
      "animation-duration": "1s",
      "animation-delay": "0.5s",
      "visibility": "visible"
    },
    attrs: {
      "src": "/static/assets/images/lianxibn3.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "donghuaLeft",
    staticStyle: {
      "height": "100%",
      "margin-left": "30%",
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "src": "/static/assets/images/lianxibn3z.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contact-form section-padding3 lianxi_section4 section"
  }, [_c('div', {
    staticClass: "zyfz001"
  }, [_c('div', {
    staticClass: "zyfz002",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    staticClass: "zhiyefazhan",
    attrs: {
      "src": "/static/assets/images/zhiyefazhan.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zyfz003"
  }, [_c('div', {
    staticClass: "zyfz3-1 donghuaLeft",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.2s",
      "visibility": "visible"
    }
  }, [_c('p', {
    staticClass: "zhiyefazhan_01",
    staticStyle: {
      "font-size": "20px",
      "color": "#cccccc6b"
    }
  }, [_vm._v("REVIEW SYSTEM")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_02",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("01 科学的任职资格评审制度")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_03"
  }, [_vm._v("针对每位员工能力素质差异，制定个人职业发展计划 通过知识技能培训，提升工作能力，经过科学评审，获得轮岗/晋升机会")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "zyfz3-2 donghuaLeft",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.5s",
      "visibility": "visible"
    }
  }, [_c('p', {
    staticClass: "zhiyefazhan_01",
    staticStyle: {
      "font-size": "20px",
      "color": "#cccccc6b"
    }
  }, [_vm._v("ENTERPRISE UNIVERSITY")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_02",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("02 拿度企业大学")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_03"
  }, [_vm._v("与知名院校合作，为员工提供高起专/专升本/工程硕士/MBA学历教育 完善的培训体系，为不同层级员工提供全方位技能/专业/管理的内外部培训课程")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "zyfz3-3"
  }, [_c('p', {
    staticClass: "donghuaRight zhiyefazhan_01",
    staticStyle: {
      "font-size": "20px",
      "color": "#cccccc6b",
      "animation-duration": "0.5s",
      "animation-delay": "0.8s",
      "visibility": "visible"
    }
  }, [_vm._v("\n              PROMOTION")]), _vm._v(" "), _c('p', {
    staticClass: "donghuaRight zhiyefazhan_02",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "animation-duration": "0.5s",
      "animation-delay": "0.8s",
      "visibility": "visible"
    }
  }, [_vm._v("\n              03 多样的员工晋升通道")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_03"
  }, [_vm._v("提供多元化晋升路径、制定明确的晋升规划、提供培训和发展机会、建立良好的激励机制。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zpgw01-1-1 donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.2s",
      "visibility": "visible"
    }
  }, [_c('p', {
    staticClass: "zhiyefazhan_02",
    staticStyle: {
      "color": "#E91E63"
    }
  }, [_vm._v("RECRUITING POSITIONS")]), _vm._v(" "), _c('p', {
    staticClass: "rencai1",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("招聘岗位")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/lxwmzpgw.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.3s"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2 toubugaodu",
    staticStyle: {
      "height": "400px",
      "background": "url('../static/assets/images/bannerc.jpg') no-repeat",
      "background-size": "100% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_tab"
  }, [_c('router-link', {
    staticClass: "about_tab_jj",
    staticStyle: {
      "background": "#0473db",
      "color": "#ffffff"
    },
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_wh",
    attrs: {
      "to": "/wenhua"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_jg",
    attrs: {
      "to": "/jiagou"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业架构")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_zr",
    attrs: {
      "to": "/zeren"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("认证体系")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_sm",
    attrs: {
      "to": "/shengming"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("版权声明")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2 about_section1"
  }, [_c('div', {
    staticClass: "container about912",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0px 8%",
      "line-height": "36px",
      "font-size": "16px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row toubugaoduzt",
    staticStyle: {
      "height": "400px",
      "line-height": "400px",
      "color": "#ffffff",
      "font-size": "45px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticStyle: {
      "font-style": "initial"
    }
  }, [_vm._v("关于我们")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "130px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("烟台拿度智能科技有限公司")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "50px",
      "font-size": "16px"
    }
  }, [_vm._v("专注于工业自动化测控领域的应用产品开发与技术服务")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buxianshi",
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px",
      "padding-top": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/aboutds.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticStyle: {
      "color": "#e40230"
    }
  }, [_vm._v(" ♥ ")]), _vm._v(" 核心价值观")]), _vm._v(" "), _c('p', [_vm._v("协作 、责任 、进步")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticStyle: {
      "color": "#e40230"
    }
  }, [_vm._v(" ♥ ")]), _vm._v(" 企业愿景")]), _vm._v(" "), _c('p', [_vm._v("专注于工业自动化测控领域的应用产品开发与技术服务")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticStyle: {
      "color": "#e40230"
    }
  }, [_vm._v(" ♥ ")]), _vm._v(" 不朽使命")]), _vm._v(" "), _c('p', [_vm._v("我们追求在瞬息万变的高科技测控世界里，创造不朽的品质和价值。不朽精神将会以无限的可能传递和延申，为您，也为我们自己。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "team-area section-padding2"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "advantage_num"
  }, [_c('ul', [_c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage01.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("6")]), _c('i', [_vm._v("大")])]), _vm._v(" "), _c('p', [_vm._v("主要业务板块，"), _c('br'), _vm._v("\n                磁致伸缩位移传感器、激光传感器")])])]), _vm._v(" "), _c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage02.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("10")]), _c('i', [_vm._v("年")])]), _vm._v(" "), _c('p', [_vm._v("十年以上的行业经验，"), _c('br'), _vm._v("\n                强大的传感器研发、设计和测试工程师团队")])])]), _vm._v(" "), _c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage03.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("60")]), _c('i', [_vm._v("种")])]), _vm._v(" "), _c('p', [_vm._v("位移传感器产品，"), _c('br'), _vm._v("\n                技术上追求“度”，做事上立本于“度”")])])])])])])])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "map-area section-padding cpinfo_section1 section"
  }, [_c('div', {
    staticClass: "chanpin_info"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cpinfo.title) + "\n        ")]), _vm._v(" "), _c('P', {
    staticClass: "p3 animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "visibility": "visible"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cpinfo.description)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "banner-sunb animate zoomInRight animated",
    staticStyle: {
      "animation-duration": "2s",
      "animation-delay": "0.5s",
      "visibility": "visible"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": _vm.newurl + _vm.cpinfo.ico
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-sunc animate fadeInLeft animated"
  }, [_c('div', {
    staticClass: "ccp1"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.newurl + _vm.cpinfo.ico
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "map-area section-padding cpinfo_section2 section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jscs_s02"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ipahyyyzzz",
    staticStyle: {
      "width": "30%",
      "margin-right": "10%",
      "float": "right",
      "font-size": "14px",
      "color": "#4bbfbc"
    }
  }, [_c('div', {
    staticClass: "bianhua003",
    staticStyle: {
      "float": "right",
      "width": "250px",
      "height": "100px",
      "margin-top": "50px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.newurl + _vm.cpinfo.ext_zhegnshu,
      "target": "_blank"
    }
  }, [(_vm.cpinfo.ext_zhegnshu) ? _c('div', {
    staticStyle: {
      "width": "40%",
      "float": "left",
      "text-align": "center",
      "cursor": "pointer"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("产品手册下载")])]) : _vm._e()]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.newurl + _vm.cpinfo.ext_c3,
      "target": "_blank"
    }
  }, [(_vm.cpinfo.ext_c3) ? _c('div', {
    staticStyle: {
      "width": "40%",
      "float": "right",
      "text-align": "center",
      "cursor": "pointer"
    }
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("证书下载")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "jscs_s03"
  }, [_c('div', {
    staticClass: "zuozuozuo",
    staticStyle: {
      "float": "left",
      "width": "50%"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cpinfo.ext_xingneng)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "youyouyou",
    staticStyle: {
      "float": "right",
      "width": "50%"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cpinfo.content)
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jscs_s01"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/cpinfoban.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccvccdiv",
    staticStyle: {
      "width": "50%",
      "margin-left": "10%",
      "float": "left"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/biaoqian.jpg"
    }
  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "jishucanshuziti",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("技术参数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": "/static/assets/images/wenjian.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": "/static/assets/images/wenjian.png"
    }
  })])
}]}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section-padding8 section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tablea slider"
  }, [_c('div', {
    staticClass: "slider-container"
  }, [_c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "shojilaoxun",
    staticStyle: {
      "width": "79%",
      "height": "100%"
    }
  }, _vm._l((_vm.huobanlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xintablea"
    }, [_c('a', {
      attrs: {
        "href": item.apilink,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "donghuasunfadeIn",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.6s"
      },
      attrs: {
        "src": _vm.newurl + item['ico']
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "shojilaoxun",
    staticStyle: {
      "width": "79%",
      "height": "100%"
    }
  }, _vm._l((_vm.huobanlista), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xintablea"
    }, [_c('a', {
      attrs: {
        "href": item.apilink,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "donghuasunfadeIn",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.6s"
      },
      attrs: {
        "src": _vm.newurl + item['ico']
      }
    })])])
  }), 0)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "40px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding hezuo_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("PARTNERS")])]), _vm._v(" "), _c('div', {
    staticClass: "animate bounce animated",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/shubiao.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donghuasun hezuokuandu",
    staticStyle: {
      "width": "100%",
      "padding-top": "2%",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "30px",
      "color": "#44BCB9"
    }
  }, [_vm._v("PARTNERS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#666666"
    }
  }, [_vm._v("商务合作伙伴")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.3s"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container xinwen2912"
  }, [_c('div', {
    staticClass: "row buxianshi"
  }, [_c('div', {
    staticClass: "swiper-container",
    staticStyle: {
      "width": "100%",
      "margin": "50px 0px"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.newslunbo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide",
      staticStyle: {
        "width": "100%",
        "height": "450px"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/blogDetails?id=' + item.id + '&cid=' + _vm.thisid
      }
    }, [_c('div', {
      staticStyle: {
        "width": "50%",
        "height": "400px",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "beijingyangshi",
      style: ('background: url(' + _vm.newurl + item.ico + ')no-repeat center center; width: 100%;height:100%;')
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "50%",
        "height": "400px",
        "float": "right",
        "background": "#ffffff"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "30px",
        "line-height": "40px"
      }
    }, [_c('h4', {
      staticStyle: {
        "line-height": "60px",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.date) + " "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("阅读全文 >")])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chanpin_s2"
  }, [_vm._l((_vm.newslist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s1_02 chanpin_s1_02_xin animate zoomIn animated",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "1s"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/blogDetails?id=' + item.id + '&cid=' + _vm.thisid
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a",
      staticStyle: {
        "border-radius": "0px",
        "border": "0px"
      }
    }, [_c('div', {
      style: ('background: url(' + _vm.newurl + item.ico + ')no-repeat center center;background-size: cover !important;width: 100%;height: 200px;')
    }), _vm._v(" "), _c('div', {
      staticClass: "xinwen912",
      staticStyle: {
        "height": "150px",
        "width": "100%",
        "background": "#ffffff",
        "padding": "30px"
      }
    }, [_c('h4', {
      staticClass: "zitikaka",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(_vm.truncatechanpinzzz(item.title)))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1, true)])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "donghuaRight",
    staticStyle: {
      "width": "100%",
      "height": "30px",
      "text-align": "center",
      "line-height": "100px",
      "animation-duration": "1s",
      "animation-delay": "0.6s",
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "download-btn",
    on: {
      "click": function($event) {
        return _vm.jiazai(_vm.numzong)
      }
    }
  }, [_vm._v("\n                查看更多" + _vm._s(_vm.newtitle) + " +\n              ")])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding news_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated news_sun_ziti1",
    staticStyle: {
      "animation-duration": "0.7s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated news_sun_ziti2",
    staticStyle: {
      "animation-duration": "0.7s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "red"
    }
  }, [_vm._v("NEWS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("阅读全文 > ")])])
}]}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2 toubugaodu",
    staticStyle: {
      "height": "400px",
      "background": "url('../static/assets/images/bannerc.jpg') no-repeat",
      "background-size": "100% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_tab"
  }, [_c('router-link', {
    staticClass: "about_tab_jj",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_wh",
    staticStyle: {
      "background": "#0473db",
      "color": "#ffffff"
    },
    attrs: {
      "to": "/wenhua"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_jg",
    attrs: {
      "to": "/jiagou"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业架构")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_zr",
    attrs: {
      "to": "/zeren"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("认证体系")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_sm",
    attrs: {
      "to": "/shengming"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("版权声明")])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row toubugaoduzt",
    staticStyle: {
      "height": "400px",
      "line-height": "400px",
      "color": "#ffffff",
      "font-size": "45px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticStyle: {
      "font-style": "initial"
    }
  }, [_vm._v("关于我们")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2 wenhua_section1"
  }, [_c('div', {
    staticClass: "container julidingbu",
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "600px"
    }
  }, [_c('div', {
    staticClass: "wenhua_news wow fadeInLeft animated",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "position": "absolute",
      "top": "0px"
    }
  }, [_c('div', {
    staticClass: "wenhuaz912",
    staticStyle: {
      "width": "50%",
      "float": "left",
      "height": "250px"
    }
  }, [_c('div', {
    staticClass: "whz912",
    staticStyle: {
      "float": "left",
      "background": "#c1d2f0",
      "width": "90%",
      "margin-left": "5%",
      "border-radius": "10px",
      "height": "250px"
    }
  }, [_c('div', {
    staticClass: "wenhua912",
    staticStyle: {
      "width": "30%",
      "float": "left",
      "margin-left": "5%",
      "height": "250px",
      "line-height": "250px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/wenhua020.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wenhua2912",
    staticStyle: {
      "width": "50%",
      "float": "left",
      "text-align": "left",
      "padding-top": "80px",
      "line-height": "36px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "600"
    }
  }, [_vm._v("我们的核心价值观")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("协作 进步 责任")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wenhuaz912",
    staticStyle: {
      "width": "50%",
      "float": "left",
      "height": "250px"
    }
  }, [_c('div', {
    staticClass: "whz912",
    staticStyle: {
      "float": "left",
      "background": "#c1d2f0",
      "width": "90%",
      "margin-left": "5%",
      "border-radius": "10px",
      "height": "250px"
    }
  }, [_c('div', {
    staticClass: "wenhua912",
    staticStyle: {
      "width": "30%",
      "float": "left",
      "margin-left": "5%",
      "height": "250px",
      "line-height": "250px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/wenhua010.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wenhua2912",
    staticStyle: {
      "width": "50%",
      "float": "left",
      "text-align": "left",
      "padding-top": "46px",
      "line-height": "36px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "600"
    }
  }, [_vm._v("我们的责任")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("我们精诚团结，追求科技创新，不断进取。对员工负责、对客户负责、对股东负责、对社会及环境负责始终是拿度肩负之重任")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wenhuaz912",
    staticStyle: {
      "width": "50%",
      "float": "left",
      "height": "250px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "whz912",
    staticStyle: {
      "float": "left",
      "background": "#c1d2f0",
      "width": "90%",
      "margin-left": "5%",
      "border-radius": "10px",
      "height": "250px"
    }
  }, [_c('div', {
    staticClass: "wenhua912",
    staticStyle: {
      "width": "30%",
      "float": "left",
      "margin-left": "5%",
      "height": "250px",
      "line-height": "250px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/wenhua030.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wenhua2912",
    staticStyle: {
      "width": "50%",
      "float": "left",
      "text-align": "left",
      "padding-top": "46px",
      "line-height": "36px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "600"
    }
  }, [_vm._v("我们的行事准则")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("技术上追求“度”，做事上立本于“度”，“拿度” 始终是烟台拿度智能科技有限公司价值所向，恒基之本。")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "float": "left",
      "height": "250px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "wenhuabeijing912",
    staticStyle: {
      "float": "left",
      "width": "90%",
      "background": "url('../static/assets/images/1723017944930851.png') no-repeat",
      "background-size": "100% auto",
      "margin-left": "5%",
      "border-radius": "10px",
      "height": "250px"
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "team-area section-padding2"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "advantage_num"
  }, [_c('ul', [_c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage01.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("6")]), _c('i', [_vm._v("大")])]), _vm._v(" "), _c('p', [_vm._v("主要业务板块，"), _c('br'), _vm._v("\n                  磁致伸缩位移传感器、激光传感器")])])]), _vm._v(" "), _c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage02.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("10")]), _c('i', [_vm._v("年")])]), _vm._v(" "), _c('p', [_vm._v("十年以上的行业经验，"), _c('br'), _vm._v("\n                  强大的传感器研发、设计和测试工程师团队")])])]), _vm._v(" "), _c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage03.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("60")]), _c('i', [_vm._v("种")])]), _vm._v(" "), _c('p', [_vm._v("位移传感器产品，"), _c('br'), _vm._v("\n                  技术上追求“度”，做事上立本于“度”")])])])])])])])
}]}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container xinwennei912"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "col-lg-8 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "110px",
      "line-height": "60px",
      "border-bottom": "1px solid #cccccc"
    }
  }, [_c('h2', {
    staticClass: "news_sun_ziti2"
  }, [_vm._v(_vm._s(_vm.newsinfo.title))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6 col-sm-6"
  }, [_c('ul', [_c('li', [_vm._v("• " + _vm._s(_vm.newsinfo.date))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px !important",
      "position": "absolute",
      "right": "10%",
      "cursor": "pointer"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666666"
    }
  }, [_vm._v("浏览量：" + _vm._s(_vm.newsinfo.visits))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap",
    staticStyle: {
      "margin-top": "50px",
      "line-height": "30px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.newsinfo.content)
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "nav-area py-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 nav-right justify-content-end d-flex"
  }, [_c('div', {
    staticClass: "post-details"
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666666"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/blog?id=' + _vm.cid
    }
  }, [_c('span', {
    staticStyle: {
      "background": "#ddd",
      "padding": "5px 20px",
      "color": "#757575"
    }
  }, [_vm._v("返回列表页")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar mt-5 mt-lg-0 bbxs912 buxianshia"
  }, [_c('div', {
    staticClass: "single-widget recent-posts-widget",
    staticStyle: {
      "border": "0px",
      "background": "#f7f8fc"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("拿度推荐")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list"
  }, _vm._l((_vm.newslist), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "width": "100%",
        "height": "250px",
        "border-bottom": "1px solid #cccccc",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('router-link', {
      staticStyle: {
        "color": "#000"
      },
      attrs: {
        "to": '/blogDetails?id=' + item.id + '&cid=' + _vm.cid
      },
      nativeOn: {
        "click": function($event) {
          return _vm.reloadPage.apply(null, arguments)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      },
      attrs: {
        "src": _vm.newurl + item.ico
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "50px"
      }
    }, [_vm._v(_vm._s(_vm.truncatecontent(item.title)) + " ...")]), _vm._v(" "), _c('p', [_vm._v("• " + _vm._s(item.date))])])], 1)
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding news_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated news_sun_ziti1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated news_sun_ziti2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("NEWS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 nav-left justify-content-start d-flex"
  }, [_c('div', {
    staticClass: "post-details"
  }, [_c('p')])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2 toubugaodu",
    staticStyle: {
      "height": "400px",
      "background": "url('../static/assets/images/bannerc.jpg') no-repeat",
      "background-size": "100% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_tab"
  }, [_c('router-link', {
    staticClass: "about_tab_jj",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_wh",
    attrs: {
      "to": "/wenhua"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_jg",
    attrs: {
      "to": "/jiagou"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业架构")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_zr",
    staticStyle: {
      "background": "#0473db",
      "color": "#ffffff"
    },
    attrs: {
      "to": "/zeren"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("认证体系")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_sm",
    attrs: {
      "to": "/shengming"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("版权声明")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2 about_section1"
  }, [_c('div', {
    staticClass: "container zerentoplist",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  }), _vm._v(" "), _vm._l((_vm.stringToArray(_vm.aboutinfo.pics)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "single-job mb-4 d-lg-flex justify-content-between",
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('div', {
      staticClass: "job-text wow fadeInLeft animated zerenchongzu",
      staticStyle: {
        "padding": "40px 50px"
      }
    }, [_c('h4', {
      staticClass: "zerenziti",
      staticStyle: {
        "font-size": "18px",
        "font-weight": "500"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.stringToArrayshu(_vm.stringToArray(_vm.aboutinfo.picstitle)[index])[0]))]), _vm._v(" "), _c('ul', {
      staticClass: "mt-4 zerenkuan"
    }, [_c('li', {
      staticClass: "mb-3 zerentiku",
      staticStyle: {
        "color": "#a89d99"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.stringToArrayshu(_vm.stringToArray(_vm.aboutinfo.picstitle)[index])[1]) + "\n                    "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "jiayige1",
      staticStyle: {
        "color": "#000000",
        "line-height": "50px"
      }
    }, [_vm._v(_vm._s(_vm.stringToArrayshu(_vm.stringToArray(_vm.aboutinfo.picstitle)[index])[2]))])]), _vm._v(" "), _c('li', {
      staticClass: "buxianshi",
      staticStyle: {
        "margin-top": "80px",
        "width": "50px",
        "height": "50px",
        "line-height": "50px",
        "text-align": "center",
        "font-size": "18px",
        "background": "#dddddd",
        "color": "#a89d99"
      }
    }, [_vm._v("\n                    ▷ ")])])]), _vm._v(" "), _c('div', {
      staticClass: "job-img align-self-center wow zoomIn animated zerenimage"
    }, [_c('img', {
      attrs: {
        "src": _vm.newurl + item
      }
    })])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row toubugaoduzt",
    staticStyle: {
      "height": "400px",
      "line-height": "400px",
      "color": "#ffffff",
      "font-size": "45px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticStyle: {
      "font-style": "initial"
    }
  }, [_vm._v("关于我们")])])])])])
}]}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-area",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "search-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    staticClass: "d-md-flex justify-content-between",
    attrs: {
      "action": "#"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("所有产品")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("水泥罐搅拌站专用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("混凝土搅拌站大型")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("数控全自动JS750")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("供应滚筒式混凝土")])]), _vm._v(" "), _c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("选择型号")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("HZS35混凝土搅拌站")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("HZS50混凝土搅拌站")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("HZS60混凝土搅拌站")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("HZS75混凝土搅拌站")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "搜索关键字",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '搜索关键字'",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜索")])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "jobs-area section-padding",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("化工产品研发工程师l")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" 上海-闵行区")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("\n                        3-4年经验  |  本科  |  01-13发布  |  英语一般")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 2022-9-9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job1.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn4",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("全职")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("投递")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("化工实验室研究员/技术员")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("上海")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("\n                       |  1年经验  |  本科  |  01-13发布  |  英语良好")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 2022-9-9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job2.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn4",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("全职")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("投递")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("管道设计工程师（化工类）")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" 上海-松江区")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("\n                        |  3-4年经验  |  本科  |  01-13发布")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 2022-9-9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job3.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn4",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("全职")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("投递")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("化工质检员（包住+年底双薪）")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("武汉-东湖新技术产业开发区")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("\n                       |  无需经验  |  中技/中专  |  01-13发布")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("2022-9-9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job4.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn4",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("全职")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("投递")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("化工质检员（包住+年底双薪）")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("武汉-东湖新技术产业开发区")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("\n                       |  无需经验  |  中技/中专  |  01-13发布")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("2022-9-9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job5.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn4",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("全职")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("投递")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "more-job-btn mt-5 text-center"
  }, [_c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("更多职务")])])])])])
}]}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section-padding8 section",
    staticStyle: {
      "background": "#eaeff2"
    }
  }, [_c('div', {
    staticClass: "jiashangyigegao",
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "margin-left": "12%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "yingyongfenlei",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("右滑查看更多分类->")]), _vm._v(" "), _c('div', {
    staticClass: "search_sun wow fadeInLeft animated",
    staticStyle: {
      "animation-duration": "0.7s",
      "animation-delay": "0.2s"
    }
  }, [_c('ul', _vm._l((_vm.hangyelist), function(item, index) {
    return (item == _vm.xuanzhong) ? _c('li', {
      key: index,
      staticStyle: {
        "background": "#4ec2bf",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          return _vm.hangyexz(item)
        }
      }
    }, [_c('i', {
      class: 'biaoqian biaoqian' + index
    }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(item) + "\n              ")])]) : _c('li', {
      on: {
        "click": function($event) {
          return _vm.hangyexz(item)
        }
      }
    }, [_c('i', {
      class: 'biaoqian biaoqian' + index
    }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(item) + "\n              ")])])
  }), 0)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "yingyongfenlei",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("右滑查看更多分类->")]), _vm._v(" "), _c('div', {
    staticClass: "search_sun2 wow fadeInLeft animated",
    staticStyle: {
      "animation-duration": "0.7s",
      "animation-delay": "0.3s"
    }
  }, [_c('div', [_c('ul', [(_vm.fenleixz == 7) ? _c('li', {
    staticStyle: {
      "background": "#4ec2bf",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        return _vm.fenlei(7)
      }
    }
  }, [_c('p', [_vm._v("全部")]), _vm._v(" "), _c('p', [_vm._v("All")])]) : _c('li', {
    on: {
      "click": function($event) {
        return _vm.fenlei(7)
      }
    }
  }, [_c('p', [_vm._v("全部")]), _vm._v(" "), _c('p', [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.cplist), function(item, index) {
    return (item.scode == _vm.fenleixz) ? _c('li', {
      key: index,
      staticStyle: {
        "background": "#4ec2bf",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          return _vm.fenlei(item.scode)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.subname))])]) : _c('li', {
      on: {
        "click": function($event) {
          return _vm.fenlei(item.scode)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.subname))])])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chanpin_s1_hy"
  }, [_vm._l((_vm.prductlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s2_01 wow zoomIn animated",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.3s"
      }
    }, [_c('a', {
      attrs: {
        "href": '/chanpin?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a_hy"
    }, [_c('div', {
      staticClass: "chanpin_s101_a22"
    }, [_c('img', {
      attrs: {
        "src": _vm.newurl + item.ico
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "chanpin_s101_a23",
      staticStyle: {
        "height": "180px",
        "overflow": "hidden"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "18px",
        "color": "#4ec2bf"
      }
    }, [_vm._v(_vm._s(item.ext_c2))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#718096"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.truncatecontent(item.ext_xingneng))
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "color": "#666666",
        "width": "100%",
        "text-align": "center",
        "line-height": "60px"
      }
    }, [_vm._v(_vm._s(item.title) + "\n          ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "hy_fenye"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.fanye(1)
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _vm._l((_vm.countsum), function(n) {
    return (n == _vm.issum) ? _c('span', {
      key: n,
      staticClass: "hy_xz",
      on: {
        "click": function($event) {
          return _vm.fanye(n)
        }
      }
    }, [_vm._v("\n        " + _vm._s(n) + "\n      ")]) : _c('span', {
      on: {
        "click": function($event) {
          return _vm.fanye(n)
        }
      }
    }, [_vm._v("\n        " + _vm._s(n) + "\n      ")])
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.issum) + "/" + _vm._s(_vm.countsum))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.fanye(_vm.countsum)
      }
    }
  }, [_vm._v("尾页")])], 2)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding hangye_section1 section",
    staticStyle: {
      "height": "960px"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("行业应用")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "0.8s",
      "animation-delay": "0.5s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("INDUSTRY\n        APPLICATIONS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wow fadeInDown40 animated geiniyig",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "width": "100%",
      "text-align": "center",
      "padding": "50px 0px"
    }
  }, [_c('p'), _c('h3', {
    staticClass: "yingyongziti"
  }, [_vm._v("请尝试在所属行业中搜索您要查找的产品")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "yingyongziti2"
  }, [_vm._v(" Please try searching for the product you are looking for in your industry")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wow fadeInDown40 animated anleibiece geiniyig",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s",
      "width": "100%",
      "text-align": "center",
      "padding": "50px 0px",
      "margin-top": "50px"
    }
  }, [_c('p'), _c('h3', {
    staticClass: "yingyongziti"
  }, [_vm._v("按类别筛选")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "yingyongziti2"
  }, [_vm._v("Choose category")])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section-padding8 section genghuanbeijing",
    staticStyle: {
      "background": "url('../static/assets/images/fengdian.jpg')no-repeat center",
      "background-size": "100% 100%"
    }
  }, [_c('div', {
    staticClass: "container diannao_fangan",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "line-height": "30px",
      "font-weight": "bold"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "35%",
      "position": "absolute",
      "padding": "30px 80px",
      "font-size": "14px",
      "float": "left",
      "background": "rgba(255, 255, 255, 0.76)",
      "border-radius": "10px",
      "left": "20px",
      "bottom": "2%"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.fanganinfo.def1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "padding-bottom": "50px",
      "font-size": "14px",
      "position": "absolute",
      "top": "80px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "45%",
      "position": "absolute",
      "right": "-11%",
      "top": "-65px",
      "background": "rgba(255, 255, 255, 0.76)",
      "padding": "30px 80px",
      "border-radius": "10px"
    }
  }, [_vm._v(_vm._s(_vm.fanganinfo.def2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container shouji_fangan",
    staticStyle: {
      "display": "none",
      "padding": "25px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "line-height": "30px",
      "font-weight": "bold",
      "background": "#ffffff2e",
      "padding": "10px",
      "color": "#ffffff",
      "border-radius": "10px",
      "top": "9%",
      "width": "95%",
      "height": "80%",
      "position": "absolute"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-bottom": "0px",
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.fanganinfo.def1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding-bottom": "0px",
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.fanganinfo.def2) + "\n        ")])])])]), _vm._v(" "), _c('section', {
    staticClass: "blog-posts-area section-padding section sj_qhone"
  }, [_c('div', {
    staticClass: "shojikak sj_qiehuan"
  }, [_c('div', {
    staticClass: "chanpin_s2 diannao_fangan1",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, _vm._l((_vm.fanganlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s1_02 animate zoomIn animated",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "1s"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/jiejueinfo?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a",
      staticStyle: {
        "border-radius": "0px",
        "border": "0px"
      }
    }, [_c('div', {
      style: ('background: url(' + _vm.newurl + item.ico + ')no-repeat center center;width: 100%;height: 200px;')
    }), _vm._v(" "), _c('div', {
      staticClass: "tiaozhuan001",
      staticStyle: {
        "height": "130px",
        "width": "100%",
        "background": "#ffffff",
        "padding": "7px"
      }
    }, [_c('h4', {
      staticClass: "xinwen"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "color": "#666666"
      }
    }, [_vm._v(_vm._s(_vm.truncatecontent(item.description)) + "...")]), _vm._v(" "), _vm._m(1, true)])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "chanpin_s2 shouji_fangan1"
  }, _vm._l((_vm.fanganlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s1_02 animate zoomIn animated",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "1s"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/jiejueinfo?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a",
      staticStyle: {
        "border-radius": "0px",
        "border": "0px"
      }
    }, [_c('div', {
      style: ('background: url(' + _vm.newurl + item.ico + ')no-repeat center center;width: 100%;height: 80px;')
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "70px",
        "width": "100%",
        "background": "#ffffff",
        "padding": "7px"
      }
    }, [_c('h4', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "color": "#666666"
      }
    }, [_vm._v(_vm._s(_vm.truncatecontentb(item.description)) + "...")])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between shouji_fangan1",
    staticStyle: {
      "width": "90%",
      "margin-left": "5%"
    }
  }, [_c('div', {
    staticClass: "col-sm-6 nav-left justify-content-start d-flex",
    staticStyle: {
      "width": "40%",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "post-details",
    on: {
      "click": function($event) {
        return _vm.qiehuanzus(_vm.page)
      }
    }
  }, [_c('p', {
    staticClass: "qiehuanzu"
  }, [_vm._v("切换上一组")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 nav-right justify-content-end d-flex",
    staticStyle: {
      "width": "40%",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "post-details",
    on: {
      "click": function($event) {
        return _vm.qiehuanzux(_vm.page)
      }
    }
  }, [_c('p', {
    staticClass: "qiehuanzu"
  }, [_vm._v("切换下一组")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between diannao_fangan1",
    staticStyle: {
      "width": "90%",
      "margin-left": "5%",
      "height": "100px"
    }
  }, [_c('div', {
    staticClass: "col-sm-6 nav-left justify-content-start d-flex qiehuan_shang"
  }, [_c('div', {
    staticClass: "post-details",
    on: {
      "click": function($event) {
        return _vm.qiehuanzus(_vm.page)
      }
    }
  }, [_c('p', {
    staticClass: "qiehuanzu"
  }, [_vm._v("切换上一组")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 nav-right justify-content-end d-flex qiehuan_xia"
  }, [_c('div', {
    staticClass: "post-details",
    on: {
      "click": function($event) {
        return _vm.qiehuanzux(_vm.page)
      }
    }
  }, [_c('p', {
    staticClass: "qiehuanzu"
  }, [_vm._v("切换下一组")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "40px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding fangan_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "color": "#E91E63",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_vm._v("\n        SOLUTION")])]), _vm._v(" "), _c('div', {
    staticClass: "animate bounce animated",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/shubiao.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiaozhuan002"
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "border": "1px solid #cccccc",
      "padding": "5px 20px",
      "border-radius": "20px"
    }
  }, [_vm._v("Details\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2 toubugaodu",
    staticStyle: {
      "height": "400px",
      "background": "url('../static/assets/images/bannerc.jpg') no-repeat",
      "background-size": "100% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_tab"
  }, [_c('router-link', {
    staticClass: "about_tab_jj",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_wh",
    attrs: {
      "to": "/wenhua"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_jg",
    attrs: {
      "to": "/jiagou"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业架构")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_zr",
    attrs: {
      "to": "/zeren"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("认证体系")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_sm",
    staticStyle: {
      "background": "#0473db",
      "color": "#ffffff"
    },
    attrs: {
      "to": "/shengming"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("版权声明")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2 shengming_section1"
  }, [_c('div', {
    staticClass: "shengming_section1_one"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "animate fadeInRight40 animated shengmingkuandu",
    staticStyle: {
      "width": "50%",
      "float": "right",
      "font-size": "16px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  })])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row toubugaoduzt",
    staticStyle: {
      "height": "400px",
      "line-height": "400px",
      "color": "#ffffff",
      "font-size": "45px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticStyle: {
      "font-style": "initial"
    }
  }, [_vm._v("关于我们")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shengming_section1_one_1"
  }, [_c('div', {
    staticClass: "shengming_section1_one_2 animate fadeInLeft animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.5s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/banquan.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shengming_section1_one_3"
  }, [_c('img', {
    staticClass: "animate zoomIn animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "src": "/static/assets/images/banquan01.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shengming_section1_one_4 animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "1.5s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/banquan02.jpg"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2 shengming_section2 buxianshi"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "200px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://register.ccopyright.com.cn/query.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "index-banner"
  }, [_c('div', {
    staticClass: "g_w1200"
  }, [_c('div', {
    staticClass: "index-search"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("登记公告检索")]), _vm._v(" "), _c('div', {
    staticClass: "search",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('ul', {
    staticClass: "tabs g_clearfix",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('li', {
    staticClass: "current",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("查软件")]), _vm._v(" "), _c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("查作品")]), _vm._v(" "), _c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("查DCI")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('div', {
    staticClass: "search_box g_clearfix",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('div', {
    staticClass: "input_box",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('input', {
    staticClass: "input_register",
    attrs: {
      "data-v-7dec1380": "",
      "type": "text",
      "placeholder": "请输入精准登记号"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input_name",
    attrs: {
      "data-v-7dec1380": "",
      "type": "text",
      "placeholder": "请输入著作权人或软件名称"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    attrs: {
      "data-v-7dec1380": ""
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "search_tips g_clearfix",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('li', {
    staticClass: "title",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("例如：")]), _vm._v(" "), _c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("2018SR13332 美图美化修图软件")])]), _vm._v(" "), _c('ul', {
    staticClass: "search_subTips g_clearfix",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('li', {
    staticClass: "title",
    attrs: {
      "data-v-7dec1380": ""
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("如需检索软件登记事项变更或补充登记，请输入登记号和变更后的著作权人或软件名称")])])])])])])])])])])])
}]}

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */])

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
})
// // 监听刷新
// window.addEventListener('resize', function () {
//   const body = document.querySelector('body');
//   const backgroundImage = body.style.backgroundImage;
//   if (!backgroundImage || backgroundImage === 'none') {
//     location.reload();
//   }
// });

// // 检查页面是否是通过后退按钮加载的
// window.addEventListener('load', function () {
//   // 获取当前页面的历史记录状态值
//   let currentState = history.state;
//   // 监听 popstate 事件，当浏览器后退时触发
//   window.addEventListener('popstate', function () {
//     // 再次获取历史记录状态值，如果和初始状态值不同，说明发生了后退操作
//     if (history.state !== currentState) {
//       location.reload();
//     }
//   });
// });

/***/ })
]),[123]);


// WEBPACK FOOTER //
// static/js/app.d9abf72a7ae73ffa7244.js